import React, { useEffect, useRef, useState } from "react";
import closeIcon from "./../../assets/Images/Navbar/close.png";
import upload from "./../../assets/Images/Request_Property/upload.png";
import DocumentUploadForm from "../DocumentUploadForm/DocumentUploadForm";
import PropertiesService from "../../Services/PropertiesService";
import { toast, ToastContainer } from "react-toastify";
import logo from "../../assets/Images/LOGOS/Docity_Logo.png";
import { useNavigate, useLocation } from "react-router-dom";
import del from "./../../assets/Images/Request_Property/delete.png";
import close from "./../../assets/Images/Request_Property/close.png";
import add from "./../../assets/Images/Request_Property/add.png";
import loader from "./../../assets/Images/Request_Property/Loader.gif";
import { Button, Modal } from "react-bootstrap";
import * as pdfjsLib from "pdfjs-dist";
import DateFormate from "../DateFormat/DateFormate";
import { extractDateFromDocument, formatReadableDate } from "../../utils/dateExtractor";

import "./RequestProperty.css";
import "../Common/PrestigeStepper.css";
import "../SearchableSelect/SearchableSelect.css";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FaTrashAlt } from "react-icons/fa";
import { Product } from "../RazorPay";
import Select from "react-select";

import PaymentPreviewCard from "../PaymentPreviewCard/PaymentPreviewCard";
import FilePreview from '../Common/FilePreview';
import { getApiErrorMessage, isApiErrorResponse } from '../../utils/fileHelpers';
import { purgeExpiredUnpaidDrafts } from '../../utils/draftExpiry';
import SearchableSelect from "../SearchableSelect/SearchableSelect";
import FetchingCard from "../../Components/FetchingCard/FetchingCard";
import requestsService from "../../Services/requests";
import Footer from '../Footer/Footer';
const categories = [
  "Legal Documents",
  "R And S",
  "Commercial",
  "Technical Documents",
];



const RequestProperty = ({ propertyRequestSwitch, closeModal, ShowPrevousData }) => {
  const [stateType, setStateType] = useState("");

  const [documentFields, setDocumentsFields] = useState([
    { department: "", file: null, fields: {} },
  ]);

  const [error, setError] = useState("");

  const [FinalAmount, setFinalAmount] = useState(null);
  const [DateFormatError, setDateFormatError] = useState("");
  const [dummyData, setDepartmentList] = useState([]);
  const [manualDate, setManualDate] = useState("");
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState([
    "Legal Documents",
    "R And S",
    "Commercial",
    "Technical Documents",
  ]);

  const [filteredOptions, setFilteredOptions] = useState(dummyData);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [categoryLabels, setCategoryLabels] = useState({});
  const [isSubmittingRequest, setIsSubmittingRequest] = useState(false);
  const [isPayLaterLoading, setIsPayLaterLoading] = useState(false);

  const handleSelect = (item, currentCategory) => {
    console.log(currentCategory, 'currentCategory')

    setShowDropdown(false);
    setTextInputs((prevTextInputs) => ({
      ...prevTextInputs,
      [currentCategory]: item,
    }));
  };

  const handleSelect2 = (item, currentCategory) => {
    console.log(currentCategory, 'currentCategorywwwww')
    const formattedNew = formatCategoryName(item);
    setTextInputs((prevTextInputs) => ({
      ...prevTextInputs,
      [formattedNew]: item,
    }));
    setCategories((prev) =>
      prev.map((cat) => (cat === currentCategory ? item : cat))
    );

    setShowDropdown(false);
  };
  const formatCategoryName = (category) => {
    if (typeof category === "string") {
      return category.replace(/\s+/g, "_");
    }
    return "";
  };
  const getAllDepartmentsList = async () => {
    const response = await PropertiesService.getAllDepartments();
    if (response.message == "Success") {
      const filter = response.data.map((x) => x.name);
      setDepartmentList(filter);
    }
  };
  const [paymentDone, setPaymentDone] = useState(false);
  const [RazorPayShow, setRazorPayShow] = useState(false);
  const handleCancelPayment = () => {
    setpaymentStatusModel(false);
    // navigate("/reqProperty");
  };
  const [paymentStatusModel, setpaymentStatusModel] = useState(false);
  const initialState = categories?.reduce((acc, category) => {
    acc[formatCategoryName(category)] = [{ id: "input-1", data: null }];
    return acc;
  }, {});
  const [categories1, setCategories1] = useState(["Category_1"]);
  const [fileInputs1, setFileInputs1] = useState({
    Category_1: [],
  });
  const [textInputs, setTextInputs] = useState({
    Category_1: "",
  });
  const [dateFiles, setDateFiles] = useState({
    date: [{ id: "input-1", data: null, manualDate: null }],
  });
  const [activestepper, setActiveStepper] = useState(0);
  const [activeStep, setActiveStep] = useState("step1");
  const [formError, setFormError] = useState("");
  const [selectPropertyType, setSelectPropertyType] = useState("");
  const [selectPropertyTypeError, setSelectPropertyTypeError] = useState("");
  const [pincode, setPincode] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [Address, setAddress] = useState("");
  const [AddressError, setAddressError] = useState("");
  const [selectPropertyRegion, setSelectPropertyRegion] = useState("");
  const [PropertyEnterText, setPropertyEnterText] = useState("");

  const [selectPropertyRegionError, setSelectPropertyRegionError] =
    useState("");
  const [properRegion, setProperRegion] = useState("");
  const [properRegionError, setProperRegionError] = useState("");
  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState("");
  const [state, setState] = useState("");
  const [stateError, setStateError] = useState("");
  const [uploadErrors, setUploadErrors] = useState("");
  const [singleDocumentErrors, setSingleDocumentErrors] = useState({
    sales: "",
    owner: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [ownerLoading, setOwnerLoading] = useState(false);
  const [saleLoading, setSaleLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isChecked1, setIsChecked1] = useState(false);
  const saleAgreementRef = useRef(null);
  const ownershipDocRef = useRef(null);
  const [salesAgreement, setSalesAgreement] = useState(false);
  const [salesAgreementPreview, setSalesAgreementPreview] = useState('');
  const [fileInputs, setFileInputs] = useState(initialState);
  const [ownerShipDoc, setOwnerShipDoc] = useState();
  const [ownerShipDocPreview, setOwnerShipDocPreview] = useState('');
  const [formatType, setFormatType] = useState("");
  const [previewFile, setPreviewFile] = useState(null); // { url, previewUrl, title }
  const [userDetails, setUserDetails] = useState();
  const [PrefillLoader, setPrefillLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDraftModal, setShowDraftModal] = useState(false);
  const [draftData, setDraftData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const getDraftDocuments = (draft) => {
    const docs = [];
    if (draft?.sale_Aggrement) {
      docs.push({ name: 'Ownership Document', url: draft.sale_Aggrement });
    }
    if (draft?.Declaration && draft.Declaration !== 'true') {
      docs.push({ name: 'Declaration Document', url: draft.Declaration });
    }
    if (draft?.documents?.[0]?.files) {
      const filesObj = draft.documents[0].files;
      if (Array.isArray(filesObj)) {
        filesObj.forEach(f => {
          if (f?.file) docs.push({ name: f.name || 'Document', url: f.file, previewUrl: f.previewUrl });
        });
      } else if (typeof filesObj === 'object') {
        Object.keys(filesObj).forEach(cat => {
          const filesArray = filesObj[cat];
          if (Array.isArray(filesArray)) {
            filesArray.forEach(f => {
              if (f?.file) docs.push({ name: f.name || 'Document', url: f.file, previewUrl: f.previewUrl });
            });
          }
        });
      }
    }
    return docs.slice(0, 3);
  };
  const validatePincode = (value) => /^[0-6]{6,}$/.test(value);
  const [PropertyResponse, setPropertyResponse] = useState([]);
  const [text, setText] = useState("Upload a file to extract text.");
  const [dates, setDates] = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [StatesList, setStatesList] = useState([]);
  useEffect(() => {
    setUserDetails(JSON.parse(localStorage.getItem("userDetails")));
  }, []);

  const getActiveRequestPropertyDrafts = async () => {
    const currentUser = JSON.parse(localStorage.getItem('userDetails'));
    if (!currentUser?.user_id) return [];

    const response = await PropertiesService.getUserProperties({ userId: currentUser.user_id });
    const pendingDrafts = response?.data?.filter((x) => x.isFilled === false) || [];
    const { activeDrafts } = await purgeExpiredUnpaidDrafts({
      items: pendingDrafts,
      deleteItem: 'requestProperty',
      deleteFn: PropertiesService.DeleteProperty,
    });
    return activeDrafts;
  };

  const handleForms = async (step) => {
    const steps = ["step1", "step2", "step3", "step4"];
    const targetIndex = steps.indexOf(step);
    const currentIndex = steps.indexOf(activeStep);

    let canNavigate = true;
    if (targetIndex > currentIndex) {
      for (let i = 0; i < targetIndex; i++) {
        if (!isStepRequiredFieldsFilled(steps[i])) {
          canNavigate = false;
          break;
        }
      }
    }

    if (canNavigate) {
      setPrefillLoader(true);
      setTimeout(() => {
        setPrefillLoader(false);
        setActiveStep(step);
      }, 1000);
      setFormError("");
    } else {
      setFormError("Please fill in all required details before proceeding to the next steps.");
      setTimeout(() => setFormError(""), 3000);
    }
  };
  const handleRequestedProperty = async (e) => {
    e.preventDefault();
    if (pincode.trim().length !== 6) {
      setPincodeError("Pincode must be 6 digits");
      setTimeout(() => {
        setPincodeError("");
      }, 2000);
    } else if (!selectPropertyType.trim()) {
      setSelectPropertyTypeError("Select Property Type is required");
      setTimeout(() => {
        setSelectPropertyTypeError("");
      }, 2000);
    } else if (!Address.trim()) {
      setAddressError("Address is required");
      setTimeout(() => {
        setAddressError("");
      }, 2000);
    } else if (!selectPropertyRegion.trim()) {
      setSelectPropertyRegionError("Property Region is required");
      setTimeout(() => {
        setSelectPropertyRegionError("");
      }, 2000);
    } else if (!city.trim()) {
      setCityError("City is required");
      setTimeout(() => {
        setCityError("");
      }, 2000);
    } else if (!SelectState.trim()) {
      setStateError("State is required");
      setTimeout(() => {
        setStateError("");
      }, 2000);
    }
    else {
      setIsSubmittingRequest(true);
      try {
        if (propertyRequestSwitch == "Request Property") {
          const findFilledOrNot = await getActiveRequestPropertyDrafts();
          if (findFilledOrNot?.length > 0) {

            let obj = {
              propertyId: findFilledOrNot[0]?._id,
              userId: findFilledOrNot[0]?.userId,
              address: Address,
              propertyType: selectPropertyType,
              region:
                PropertyEnterText == "other"
                  ? properRegion
                  : selectPropertyRegion,
              city: city,
              regionType:
                PropertyEnterText == "other"
                  ? "other"
                  : '',
              state: SelectState == 'Other' ? EnterState : SelectState,
              pincode: pincode,
              stateType: SelectState == 'Other' ? SelectState : '',
              DocumentsFormat: formatType,
              sale_Aggrement: ownerShipDoc,
              Declaration: salesAgreement ? salesAgreement : isChecked1,
              isFilled: false,
            };
            console.log(obj, 'obj')
            const response = await PropertiesService.UpdateProperty(obj);
            console.log(response, 'step1 data is saved')
            setPrefillLoader(true);
            setTimeout(() => {
              setPrefillLoader(false);
              setActiveStep("step2");
            }, 1000);
          } else {
            e.preventDefault();
            setIsLoading(false);
            setOwnerLoading(false);
            if (
              !AddressError &&
              !selectPropertyTypeError &&
              !selectPropertyRegionError &&
              !cityError &&
              !stateError &&
              !pincodeError &&
              ownerShipDoc
            ) {
              setPrefillLoader(true);
              setTimeout(() => {
                setPrefillLoader(false);
                setActiveStep("step2");
              }, 1000);
              let obj = {
                address: Address,
                propertyType: selectPropertyType,
                region:
                  PropertyEnterText == "other"
                    ? properRegion
                    : selectPropertyRegion,
                city: city,
                regionType:
                  PropertyEnterText == "other"
                    ? "other"
                    : '',
                state: state,
                state: SelectState == 'Other' ? EnterState : SelectState,
                pincode: pincode,
                stateType: SelectState == 'Other' ? SelectState : '', userId: userDetails ? userDetails.user_id : null,
                DocumentsFormat: formatType,
                sale_Aggrement: ownerShipDoc,
                Declaration: salesAgreement ? salesAgreement : isChecked1,
                isFilled: false,
              };
              console.log(obj, 'obj')
              const response = await PropertiesService.requestProperty(obj);
              console.log(response, 'step1 data is saved')
            }
          }

        } else {
          setTimeout(() => {
            toast.success("This Feature get Enabled in Future");
          }, 200);
        }
      } catch (error) {
        toast.error(error?.message || "Unable to save request property details");
      } finally {
        setIsSubmittingRequest(false);
      }
    }
  };
  const handlePropertyType = (e) => {
    const value = e.target.value;
    setSelectPropertyType(value);
    if (!value) {
      setSelectPropertyTypeError("Property Type is required");
    } else {
      setSelectPropertyTypeError("");
    }
  };
  const handlePincode = async (e) => {
    let value = e.target.value;

    value = blockSpaces(value);
    if (!/^\d{0,6}$/.test(value)) return;

    setPincode(value);

    if (value.length < 6) {
      setPincodeError("");
      return;
    }

    try {
      const obj = { pincode: value };
      const response = await PropertiesService.getAddressByPincode(obj);

      const rawAddressData = response?.data || response?.result || response;
      const addressData = Array.isArray(rawAddressData)
        ? rawAddressData?.[0]
        : rawAddressData;

      if (!addressData || typeof addressData !== "object") {
        setPincodeError("Unable to fetch details for this pincode");
        return;
      }

      const cityValue =
        addressData?.city ||
        addressData?.district ||
        addressData?.division ||
        addressData?.districtName ||
        "";

      const stateValue =
        addressData?.state ||
        addressData?.stateName ||
        addressData?.state_name ||
        "";

      const regionValue =
        addressData?.region ||
        addressData?.taluk ||
        addressData?.mandal ||
        addressData?.area ||
        "";

      const addressValue =
        addressData?.fullAddress ||
        addressData?.address ||
        [
          addressData?.postOffice,
          addressData?.locality,
          addressData?.district,
          addressData?.state,
          addressData?.pincode || value,
        ]
          .filter(Boolean)
          .join(", ");

      if (cityValue) setCity(cityValue);
      if (stateValue) setSelectState(stateValue);
      if (addressValue) setAddress(addressValue);
      if (regionValue) setSelectPropertyRegion(regionValue);

      if (cityValue || stateValue || addressValue || regionValue) {
        setPincodeError("");
      } else {
        setPincodeError("Unable to fetch details for this pincode");
      }
    } catch (error) {
      setPincodeError("Unable to fetch details for this pincode");
    }
  };

  const handleAddress = (e) => {
    let value = e.target.value;

    value = value.trimStart();

    setAddress(value);

    if (!value) {
      setAddressError("Address is required");
    } else {
      setAddressError("");
    }
  };
  const preventSpace = (e) => {
    if (e.key === " ") e.preventDefault();
  };


  const blockSpaces = (value) => value.replace(/\s+/g, "");

  const handlePropertyRegion = (e) => {
    let value = e.target.value;

    value = value.replace(/[0-9]/g, "");

    value = value.replace(/[^A-Za-z ]/g, "");

    value = blockSpaces(value);

    setSelectPropertyRegion(value);

    if (!value.trim()) {
      setSelectPropertyRegionError("Property Region is required");
    } else {
      setSelectPropertyRegionError("");
    }
  };

  const handleEnterPropertyRegion = (e) => {
    let value = e.target.value;

    value = value.replace(/[0-9]/g, "");
    value = value.replace(/[^A-Za-z ]/g, "");
    value = blockSpaces(value);

    setProperRegion(value);

    if (!value.trim()) {
      setProperRegionError("Property Region is required");
    } else {
      setProperRegionError("");
    }
  };

  const [SelectState, setSelectState] = useState('')
  const [SelectStateError, setSelectStateError] = useState('')
  const [EnterState, setEnterState] = useState('')
  const handleEnterState = (e) => {
    let value = e.target.value;

    value = value.replace(/[0-9]/g, "");

    value = value.replace(/[^A-Za-z\s]/g, "");

    value = value.replace(/\s+/g, " ");

    value = value.replace(/^\s+/, "");

    value = value.replace(/\s+$/, "");

    setEnterState(value);

    if (!value.trim()) {
      setStateError("Please enter a valid State");
    } else {
      setStateError("");
    }
  };

  const handleCity = (e) => {
    let value = e.target.value;

    value = value.replace(/[0-9]/g, "");
    value = value.replace(/[^A-Za-z]/g, "");
    value = blockSpaces(value);

    setCity(value);

    if (!value.trim()) {
      setCityError("City Name is required");
    } else {
      setCityError("");
    }
  };

  const submitPropertyRequest = async () => {
    if (isSubmittingRequest) return;
    setIsSubmittingRequest(true);
    try {
      if (formatType === "date") {
        const datess = sanitizeFileInputs(dateFiles);
        const hasEmptyDate = datess?.date?.some(
          (file) => !file.manualDate || file.manualDate.trim() === ""
        );
        const hasresponddeclare = datess?.date?.some(
          (file) => !file.declare
        );
        if (hasEmptyDate) {
          setDateFormatError("Please fill in all manual dates for the documents.");
          setTimeout(() => {
            setDateFormatError("");
          }, 2000);
          return;
        } else if (hasresponddeclare) {
          setDateFormatError("Please confirm whether all dates are correct.");
          setTimeout(() => {
            setDateFormatError("");
          }, 2000);
          return;
        } else {
          let obj22 = {
            userId: userDetails ? userDetails.user_id : null,
          };
          const response222 = await PropertiesService.getUserProperties(obj22);
          const filterWithFilledData = response222?.data.filter((x) => x.isFilled == false)
          console.log(filterWithFilledData, 'filterWithFilledData')
          if (filterWithFilledData?.length > 0) {
            console.log('working11')
            let obj = {
              address: filterWithFilledData[0].address,
              propertyType: filterWithFilledData[0].propertyType,
              region: filterWithFilledData[0].region,
              city: filterWithFilledData[0].city,
              state: filterWithFilledData[0].state,
              pincode: filterWithFilledData[0].pincode,
              userId: userDetails ? userDetails.user_id : null,
              DocumentsFormat: formatType,
              sale_Aggrement: filterWithFilledData[0].sale_Aggrement,
              Declaration: filterWithFilledData[0].Declaration,
              propertyId: filterWithFilledData[0]?._id,
              documents:
                formatType === "department"
                  ? {
                    categories: categories1,
                    files: sanitizeFileInputs2(fileInputs1),
                    descriptions: textInputs,
                  }
                  : formatType === "date"
                    ? sanitizeFileInputs(dateFiles)
                    : {
                      regularcategories: categories,
                      files: sanitizeFileInputs(fileInputs),
                      descriptions: textInputs,
                    },
              paymentStatus: "Pending",
            };
            console.log(obj, 'obj1')
            const response2222 = await PropertiesService.UpdateProperty(obj);
            console.log(response2222, 'responsesssssss')
            if (response2222.message == "Success") {
              setPropertyResponse(response2222.data);
              setActiveStep("step4");
            } else {
              setTimeout(() => {
                toast.error(response2222);
              }, 200);
            }
          } else {
            console.log('working22')
            let obj = {
              address: Address,
              propertyType: selectPropertyType,
              region:
                selectPropertyRegion == "other"
                  ? properRegion
                  : selectPropertyRegion,
              city: city,
              state: state,
              pincode: pincode,
              userId: userDetails ? userDetails.user_id : null,
              DocumentsFormat: formatType,
              sale_Aggrement: ownerShipDoc,
              Declaration: salesAgreement ? salesAgreement : isChecked1,

              documents:
                formatType === "department"
                  ? {
                    categories: categories1,
                    files: sanitizeFileInputs2(fileInputs1),
                    descriptions: textInputs,
                  }
                  : formatType === "date"
                    ? sanitizeFileInputs(dateFiles)
                    : {
                      regularcategories: categories,
                      files: sanitizeFileInputs(fileInputs),
                      descriptions: textInputs,
                    },
              paymentStatus: "Pending",
            };
            console.log(obj, 'obj2')
            const response = await PropertiesService.requestProperty(obj);
            if (response.message == "Success") {
              setPropertyResponse(response.data);
              setpaymentStatusModel(false);
              setActiveStep("step4");
            } else {
              setTimeout(() => {
                toast.error(response);
              }, 200);
            }
          }
        }
      } else {
        let obj22 = {
          userId: userDetails ? userDetails.user_id : null,
        };
        const response222 = await PropertiesService.getUserProperties(obj22);
        const filterWithFilledData = response222?.data.filter((x) => x.isFilled == false)
        if (filterWithFilledData?.length > 0) {
          let obj = {
            address: filterWithFilledData[0].address,
            propertyType: filterWithFilledData[0].propertyType,
            region: filterWithFilledData[0].region,
            city: filterWithFilledData[0].city,
            state: filterWithFilledData[0].state,
            pincode: filterWithFilledData[0].pincode,
            userId: userDetails ? userDetails.user_id : null,
            DocumentsFormat: formatType,
            sale_Aggrement: filterWithFilledData[0].sale_Aggrement,
            Declaration: filterWithFilledData[0].Declaration,
            propertyId: filterWithFilledData[0]?._id,
            documents:
              formatType === "department"
                ? {
                  categories: categories1,
                  files: sanitizeFileInputs2(fileInputs1),
                  descriptions: textInputs,
                }
                : formatType === "date"
                  ? sanitizeFileInputs(dateFiles)
                  : {
                    regularcategories: categories,
                    files: sanitizeFileInputs(fileInputs),
                    descriptions: textInputs,
                  },
            paymentStatus: "Pending",
          };
          console.log(obj, 'obj3')
          const response = await PropertiesService.UpdateProperty(obj);
          if (response.message == "Success") {
            setPropertyResponse(response.data);
            setpaymentStatusModel(false);
            setActiveStep("step4");
          } else {
            setTimeout(() => {
              toast.error(response);
            }, 200);
          }
        } else {
          let obj = {
            address: Address,
            propertyType: selectPropertyType,
            region:
              selectPropertyRegion == "other"
                ? properRegion
                : selectPropertyRegion,
            city: city,
            state: state,
            pincode: pincode,
            userId: userDetails ? userDetails.user_id : null,
            DocumentsFormat: formatType,
            sale_Aggrement: ownerShipDoc,
            Declaration: salesAgreement ? salesAgreement : isChecked1,
            documents:
              formatType === "department"
                ? {
                  categories: categories1,
                  files: sanitizeFileInputs2(fileInputs1),
                  descriptions: textInputs,
                }
                : formatType === "date"
                  ? sanitizeFileInputs(dateFiles)
                  : {
                    regularcategories: categories,
                    files: sanitizeFileInputs(fileInputs),
                    descriptions: textInputs,
                  },
            paymentStatus: "Pending",
          };
          console.log(obj, 'obj4')
          const response = await PropertiesService.requestProperty(obj);
          if (response.message == "Success") {
            setPropertyResponse(response.data);
            setpaymentStatusModel(false);
            setActiveStep("step4");
          } else {
            setTimeout(() => {
              toast.error(response);
            }, 200);
          }
        }
      }
    } catch (error) {
      setTimeout(() => {
        toast.error(error.toString());
      }, 200);
    } finally {
      setIsSubmittingRequest(false);
    }
  };
  const handleCheckboxChange1 = () => {
    setIsChecked1((prev) => !prev);
  };
  const handleFileUpload1 = async (event, name) => {
    const file = event.target.files[0];
    if (!file) return;

    // Check file size limits for uploads
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      const errorMsg = `File size (${(file.size / (1024 * 1024)).toFixed(1)}MB) exceeds the maximum limit of 10MB. Please choose a smaller file.`;
      setSingleDocumentErrors((prev) => ({
        ...prev,
        [name]: errorMsg,
      }));
      toast.error(errorMsg);
      return;
    }

    const f = new FormData();
    f.append("image", file);
    if (name == "sales") {
      setSaleLoading(true);
      try {
        const response = await PropertiesService.UploadFiles(f);
        if (isApiErrorResponse(response)) {
          setSingleDocumentErrors((prev) => ({
            ...prev,
            sales: getApiErrorMessage(response, 'Unable to upload sale agreement'),
          }));
        } else {
          setUploadErrors('');
          setSingleDocumentErrors((prev) => ({ ...prev, sales: '' }));
          setSalesAgreement(response.Location);
          setSalesAgreementPreview(response.previewUrl || response.Location);
        }
      } catch (error) {
        setSingleDocumentErrors((prev) => ({
          ...prev,
          sales: getApiErrorMessage(error, 'Unable to upload sale agreement'),
        }));
      } finally {
        setSaleLoading(false);
      }
    } else {
      setOwnerLoading(true);
      try {
        const response = await PropertiesService.UploadFiles(f);
        if (isApiErrorResponse(response)) {
          setSingleDocumentErrors((prev) => ({
            ...prev,
            owner: getApiErrorMessage(response, 'Unable to upload ownership document'),
          }));
        } else {
          setUploadErrors('');
          setSingleDocumentErrors((prev) => ({ ...prev, owner: '' }));
          setOwnerShipDoc(response.Location);
          setOwnerShipDocPreview(response.previewUrl || response.Location);
        }
      } catch (error) {
        setSingleDocumentErrors((prev) => ({
          ...prev,
          owner: getApiErrorMessage(error, 'Unable to upload ownership document'),
        }));
      } finally {
        setOwnerLoading(false);
      }
    }
  };
  const handleClose = () => {
    setpaymentStatusModel(false);
    resetAadhaarState();
  };
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [aadhaarOtp, setAadhaarOtp] = useState("");
  const [aadhaarReferenceId, setAadhaarReferenceId] = useState("");
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  const [isSendingAadhaarOtp, setIsSendingAadhaarOtp] = useState(false);
  const [isVerifyingAadhaarOtp, setIsVerifyingAadhaarOtp] = useState(false);
  const [aadhaarError, setAadhaarError] = useState("");
  const [aadhaarSuccessMessage, setAadhaarSuccessMessage] = useState("");
  const [showAadhaarOtpModal, setShowAadhaarOtpModal] = useState(false);

  const resetAadhaarState = () => {
    setAadhaarNumber("");
    setAadhaarOtp("");
    setAadhaarReferenceId("");
    setIsAadhaarVerified(false);
    setIsSendingAadhaarOtp(false);
    setIsVerifyingAadhaarOtp(false);
    setAadhaarError("");
    setAadhaarSuccessMessage("");
    setShowAadhaarOtpModal(false);
  };

  const handleAadhaarNumberChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 12);
    setAadhaarNumber(digits);
    setIsAadhaarVerified(false);
    setAadhaarOtp("");
    setAadhaarReferenceId("");
    setShowAadhaarOtpModal(false);
    setAadhaarError("");
    setAadhaarSuccessMessage("");
  };

  const handleAadhaarOtpChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 6);
    setAadhaarOtp(digits);
    setAadhaarError("");
  };

  const handleSendAadhaarOtp = async () => {
    if (isSendingAadhaarOtp) return;
    if (aadhaarNumber.length !== 12) {
      setAadhaarError("Aadhaar number must be 12 digits.");
      return;
    }
    setAadhaarError("");
    setAadhaarOtp("");
    setAadhaarReferenceId("");
    setShowAadhaarOtpModal(false);
    setIsAadhaarVerified(true);
    setAadhaarSuccessMessage("Aadhaar verified successfully.");
    toast.success("Aadhaar verified successfully.");
  };

  const handleVerifyAadhaarOtp = async () => {
    if (isVerifyingAadhaarOtp) return;
    if (!aadhaarReferenceId) {
      setAadhaarError("Please send OTP first.");
      return;
    }
    if (aadhaarOtp.length !== 6) {
      setAadhaarError("OTP must be 6 digits.");
      return;
    }
    setIsVerifyingAadhaarOtp(true);
    setAadhaarError("");
    setAadhaarSuccessMessage("");
    try {
      const response = await requestsService.validateAadharOtp({
        reference_id: String(aadhaarReferenceId),
        otp: aadhaarOtp,
      });
      if (typeof response === "string") throw new Error(response);
      const message = response?.data?.message || response?.message || "";
      const isVerified =
        response?.code === 200 || /verified|success/i.test(String(message || ""));
      if (!isVerified || /invalid/i.test(String(message || ""))) {
        throw new Error(message || "Invalid OTP");
      }
      setIsAadhaarVerified(true);
      setAadhaarSuccessMessage("Aadhaar verified successfully.");
      setShowAadhaarOtpModal(false);
      toast.success("Aadhaar verified successfully.");
    } catch (error) {
      const message = getApiErrorMessage(error, "Failed to verify Aadhaar OTP");
      setIsAadhaarVerified(false);
      setAadhaarError(message);
      toast.error(message);
    } finally {
      setIsVerifyingAadhaarOtp(false);
    }
  };

  const handlePayLater = async () => {
    if (isPayLaterLoading) return;
    if (!isAadhaarVerified) {
      setAadhaarError("Please verify Aadhaar before proceeding.");
      toast.error("Please verify Aadhaar before proceeding.");
      return;
    }
    setIsPayLaterLoading(true);
    try {
      const propertyId = PropertyResponse?._id || PropertyResponse?.propertyId;

      if (!propertyId) {
        toast.error("Property not found to update payment status");
        return;
      }

      const userId = PropertyResponse?.userId || userDetails?.user_id;
      const propertiesResponse = await PropertiesService.getUserProperties({ userId });
      const latestProperty = propertiesResponse?.data?.find(
        (item) => item?._id === propertyId
      );

      const updatePayload = {
        ...(latestProperty || PropertyResponse),
        propertyId,
        userId,
        Payment_Status: true,
        paymentStatus: "Paid",
        isFilled: true,
      };

      const updateResponse = await PropertiesService.UpdateProperty(updatePayload);
      console.log(updateResponse, 'updateResponse')
      if (updateResponse?.message === "Success") {
        const updatedProperty = updateResponse?.data || {
          ...PropertyResponse,
          Payment_Status: true,
          paymentStatus: "Paid",
          isFilled: true,
        };

        setPropertyResponse(updatedProperty);
        setPaymentDone(true);
        setpaymentStatusModel(false);

        if (updatedProperty?._id) {
          localStorage.setItem("propertyDetails", JSON.stringify(updatedProperty));
        } else {
          localStorage.removeItem("propertyDetails");
        }

        toast.success("Marked as paid. Redirecting to properties...");
        if (typeof closeModal === "function") {
          closeModal();
        }
        navigate("/reqProperty", { replace: true });
      } else {
        toast.error(updateResponse || "Unable to mark payment as paid");
      }
    } catch (error) {
      toast.error("Unable to mark payment as paid");
    } finally {
      setIsPayLaterLoading(false);
    }
  };

  const RouteToProperties = () => {
    setIsModalOpen(!isModalOpen);
    setTimeout(() => {
      toast.success("Property Registered");
    }, 200);

    if (PropertyResponse) {
      localStorage.setItem("propertyDetails", JSON.stringify(PropertyResponse));
    }

    navigate("/reqProperty");

  };
  const onLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };
  const onError = () => {
    setIsLoading(false);
    setHasError(true);
  };
  const extractTextFromTXT = (file) => {
    const reader = new FileReader();
    reader.readAsText(file);

    reader.onload = () => {
      const extractedText = reader.result;
      setText(extractedText);
      extractData(extractedText);
    };

    reader.onerror = () => {
      setText("Error reading file.");
    };
  };
  const extractData = (text) => {
    const meetingDatePattern = /Date:\s*(\d{2}:\d{2}:\d{4})/g;
    const foundMeetingDates = [];
    let match;

    while ((match = meetingDatePattern.exec(text)) !== null) {
      foundMeetingDates.push(match[1]);
    }
    if (foundMeetingDates.length > 0) {
      setManualDate(foundMeetingDates[0]);
    }

    const phonePattern =
      /\+?\d{1,3}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g;
    const foundPhones = text.match(phonePattern) || [];
    setPhoneNumbers(foundPhones);
  };
  const handleFormats = (e) => {
    const value = e.target.value;
    setFormatType(value);
  };
  const handleClick = (inputRef) => {
    if (inputRef) inputRef.click();
  };
  const sanitizeFileInputs = (fileInputs) => {
    return Object.keys(fileInputs || {}).reduce((acc, category) => {
      const sanitizedFiles = (fileInputs[category] || [])
        .filter(file => file.data)
        .map(({ ref, ...rest }) => ({ ...rest, isExtracting: false }));

      if (sanitizedFiles.length > 0) {
        acc[category] = sanitizedFiles;
      }

      return acc;
    }, {});
  };
  const sanitizeFileInputs2 = (fileInputs) => {
    return Object.keys(fileInputs).reduce((acc, category) => {
      const sanitizedFiles = fileInputs[category]
        .filter(file => file?.file || file?.name)
        .map(({ ref, ...rest }) => rest);

      if (sanitizedFiles.length > 0) {
        acc[category] = sanitizedFiles;
      }

      return acc;
    }, {});
  };
  const wrapperRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const extractTextFromPDF = async (file) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async () => {
      const pdfData = new Uint8Array(reader.result);
      const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
      let extractedText = "";
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map((item) => item.str).join(" ");
        extractedText += pageText + "\n";
      }
      setText(extractedText);
      extractData(extractedText);
    };
    reader.onerror = () => {
      setText("Error reading PDF file.");
    };
  };
  const handleManualDateChange = (type, value, category, id) => {
    setDateFiles((prev) => {
      const updatedCategory = prev[category]
        ? prev[category].map((input) =>
          input.id === id
            ? {
              ...input,
              manualDate: type === "date" ? value : input.manualDate,
              declare: type === "declare" ? value : input.declare,
            }
            : input
        )
        : [];

      const updated = {
        ...prev,
        [category]: updatedCategory,
      };

      saveData(updated);
      return updated;
    });
  };

  const handleFileUpload = async (e, category, id) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      const errorMsg = `File size (${(file.size / (1024 * 1024)).toFixed(1)}MB) exceeds the maximum limit of 10MB. Please choose a smaller file.`;
      setFileInputs((prev) => {
        const formattedCategory = formatCategoryName(category);
        const updatedCategory = (prev[formattedCategory] || []).map((input) =>
          input.id === id ? { ...input, uploadError: errorMsg } : input
        );
        return {
          ...prev,
          [formattedCategory]: updatedCategory,
        };
      });
      toast.error(errorMsg);
      return;
    }

    const f = new FormData();
    f.append("image", file);
    setIsLoading(true);
    try {
      const response = await PropertiesService.UploadFiles(f);
      if (isApiErrorResponse(response)) {
        const message = getApiErrorMessage(response, `Unable to upload document under ${category}`);
        setFileInputs((prev) => {
          const formattedCategory = formatCategoryName(category);
          const updatedCategory = (prev[formattedCategory] || []).map((input) =>
            input.id === id ? { ...input, uploadError: message } : input
          );
          return {
            ...prev,
            [formattedCategory]: updatedCategory,
          };
        });
        return;
      }
      const data = response.Location;
      const previewUrl = response.previewUrl || response.Location;
      const formattedCategory = formatCategoryName(category);
      setUploadErrors('');
      setIsLoading(false);
      setFileInputs((prev) => {
        const updatedCategory = prev[formattedCategory]
          ? prev[formattedCategory].map((input) =>
            input.id === id ? { ...input, data, previewUrl, fileSize: file.size, uploadError: '' } : input
          )
          : [];
        const updated = {
          ...prev,
          [formattedCategory]: updatedCategory,
        };
        saveData(updated);
        return updated;
      });
    } catch (error) {
      setIsLoading(false);
      const message = getApiErrorMessage(error, 'File upload failed');
      setFileInputs((prev) => {
        const formattedCategory = formatCategoryName(category);
        const updatedCategory = (prev[formattedCategory] || []).map((input) =>
          input.id === id ? { ...input, uploadError: message } : input
        );
        return {
          ...prev,
          [formattedCategory]: updatedCategory,
        };
      });
    } finally {
      setIsLoading(false);
    }
  };
  const addFileInput = (category) => {
    if (!category) return;

    setManualDate([]);

    const formattedCategory = formatCategoryName(category);

    setFileInputs((prev) => {
      const existingFiles = prev[formattedCategory] || [];
      const newInput = {
        id: `input-${existingFiles.length + 1}`,
        data: null,
        ref: React.createRef(),
        loading: false,
        file: null,
      };
      return {
        ...prev,
        [formattedCategory]: [...existingFiles, newInput],
      };
    });
  };
  const removeFileInput = (category, id) => {
    const formattedCategory = formatCategoryName(category);
    if (fileInputs[formattedCategory] && fileInputs[formattedCategory].length > 0) {
      setFileInputs((prev) => {
        const filtered = (prev[formattedCategory] || []).filter((input) => input.id !== id);
        return {
          ...prev,
          [formattedCategory]: filtered.length > 0 ? filtered : [{ id: "input-1", data: null }],
        };
      });
    }
  };
  useEffect(() => {
    getAllDepartmentsList();
    getAllStates();
    const navigationEntries = performance.getEntriesByType('navigation');
    const isReload =
      (navigationEntries.length > 0 && navigationEntries[0].type === 'reload') ||
      (window.performance && window.performance.navigation && window.performance.navigation.type === 1);

    if (!isReload) {
      (async () => {
        const drafts = await getActiveRequestPropertyDrafts();
        if (drafts && drafts.length > 0) {
          setDraftData(drafts[0]);
          setShowDraftModal(true);
        }
      })();
    }
  }, []);
  const getAllStates = async () => {
    const getStates = await PropertiesService.getAllStatesList()
    if (getStates.message == 'Success') {
      setStatesList(getStates.data)
    }
    console.log(getStates.data, 'getStates')
  }
  const saveData = async (updatedDateFiles = dateFiles) => {
    const findFilledOrNot = await getActiveRequestPropertyDrafts();
    if (findFilledOrNot?.length > 0) {
      const draft = findFilledOrNot[0];
      let obj = {
        address: draft.address || Address,
        propertyType: draft.propertyType || selectPropertyType,
        region: draft.region || (selectPropertyRegion === "other" ? properRegion : selectPropertyRegion),
        city: draft.city || city,
        state: draft.state || state,
        pincode: draft.pincode || pincode,
        userId: draft.userId || (userDetails ? userDetails.user_id : null),
        DocumentsFormat: formatType || draft.DocumentsFormat || "date",
        sale_Aggrement: draft.sale_Aggrement || ownerShipDoc,
        Declaration: draft.Declaration || (salesAgreement ? salesAgreement : isChecked1),
        propertyId: draft._id,
        documents:
          formatType === "department"
            ? {
              categories: categories1,
              files: sanitizeFileInputs2(fileInputs1),
              descriptions: textInputs,
            }
            : formatType === "date"
              ? sanitizeFileInputs(updatedDateFiles)
              : {
                regularcategories: categories,
                files: sanitizeFileInputs(fileInputs),
                descriptions: textInputs,
              },
      };
      console.log(obj, 'obj')
      const response = await PropertiesService.UpdateProperty(obj);
      console.log(response, 'step2 data is saved')
    }
  }
  const getPropertyDetails = async () => {
    setPrefillLoader(true)
    const findFilledOrNot = await getActiveRequestPropertyDrafts();
    if (findFilledOrNot?.length > 0) {
      setPrefillLoader(false)
      setSelectPropertyType(findFilledOrNot[0]?.propertyType)
      setPincode(findFilledOrNot[0]?.pincode)
      setAddress(findFilledOrNot[0]?.address)
      if (findFilledOrNot[0]?.regionType == 'other') {
        setPropertyEnterText('other')
        setProperRegion(findFilledOrNot[0]?.region)
        setSelectPropertyRegion('other')
      } else {
        setPropertyEnterText('ss')
        setProperRegion('')
        setSelectPropertyRegion(findFilledOrNot[0]?.region)
      }
      if (findFilledOrNot[0]?.stateType == 'Other') {
        setSelectState('Other')
        setEnterState(findFilledOrNot[0]?.state)
      } else {
        setSelectState(findFilledOrNot[0]?.state)
      }
      setCity(findFilledOrNot[0]?.city)
      if (findFilledOrNot[0]?.Declaration == 'true') {
        setIsChecked1(true)
      } else {
        setIsChecked1(false)
        setSalesAgreement(findFilledOrNot[0]?.Declaration)
        setSalesAgreementPreview(findFilledOrNot[0]?.Declaration)
      }
      setOwnerShipDoc(findFilledOrNot[0]?.sale_Aggrement)
      setOwnerShipDocPreview(findFilledOrNot[0]?.sale_Aggrement)
      setActiveStep('step2')
      setIsLoading(false)
      setFormatType(findFilledOrNot[0]?.DocumentsFormat)
      if (findFilledOrNot[0]?.DocumentsFormat === 'department') {
        setCategories1(findFilledOrNot[0]?.documents[0]?.categories)
        setFileInputs1(findFilledOrNot[0]?.documents[0]?.files)
        setTextInputs(findFilledOrNot[0]?.documents[0]?.descriptions)
      }
      if (findFilledOrNot[0]?.DocumentsFormat === 'date') {
        const rawDateDocs = findFilledOrNot[0]?.documents[0] || {};
        const cleanedDateDocs = Object.keys(rawDateDocs).reduce((acc, category) => {
          if (Array.isArray(rawDateDocs[category])) {
            acc[category] = rawDateDocs[category].map((file) => ({ ...file, isExtracting: false }));
          } else {
            acc[category] = rawDateDocs[category];
          }
          return acc;
        }, {});
        setDateFiles(cleanedDateDocs);
      }
      if (findFilledOrNot[0]?.DocumentsFormat === 'regular') {
        setCategories(findFilledOrNot[0]?.documents[0]?.regularcategories)
        setFileInputs(findFilledOrNot[0]?.documents[0]?.files)
        setTextInputs(findFilledOrNot[0]?.documents[0]?.descriptions)
      }
    }
  }
  const handleStepClick = (index, name) => {
    if (index <= activestepper) {
      setActiveStepper(index);
      return;
    }
    if (formatType === "regular") {
      const allPreviousStepsCompleted = categories
        .slice(0, index)
        .every((category) => {
          const formattedCategory = formatCategoryName(category);
          return (
            fileInputs[formattedCategory] &&
            fileInputs[formattedCategory].some((input) => input.data)
          );
        });
      if (allPreviousStepsCompleted) {
        setActiveStepper(index);
      } else {
        setError(`Please Upload the documents ${name}`)
        setTimeout(() => {
          setError("")
        }, 3000)
      }
    } else if (formatType === "date") {
      const dateList = dateFiles?.date || [];
      const uploadedFiles = dateList.filter(file => file && (file.data || file.file));
      const hasEmptyDate = uploadedFiles.length === 0 || uploadedFiles.some(file => !file.manualDate || String(file.manualDate).trim() === "");
      const hasUnconfirmedDate = uploadedFiles.some(file => !file.declare);

      if (!hasEmptyDate && !hasUnconfirmedDate) {
        setActiveStepper(index);
      } else if (hasEmptyDate) {
        setDateFormatError("Please select or enter the date for your uploaded document.");
        toast.error("Please select or enter the date for your uploaded document.");
        setTimeout(() => setDateFormatError(""), 3000);
      } else {
        setDateFormatError("Please confirm that the date is correct by checking 'I confirm this date is correct'.");
        toast.error("Please check 'I confirm this date is correct' for your document.");
        setTimeout(() => setDateFormatError(""), 3000);
      }
    } else if (formatType === "department") {
      setActiveStepper(index);
    }
  };
  const [DepartmentValidationError, setDepartmentValidationError] = useState("")
  const handleNext = async (e) => {
    e.preventDefault();
    if (formatType === "regular") {

      const currentCategory = categories[activestepper];
      const formattedCategory = formatCategoryName(currentCategory);
      const files = fileInputs[formattedCategory] || [];
      const hasValidFile = files.some(file => file.data || file.file);

      if (hasValidFile) {
        if (activestepper === categories.length - 1) {
          setPrefillLoader(true);
          setTimeout(() => {
            setPrefillLoader(false);
            setActiveStep("step3");
          }, 1000);
        } else {
          setActiveStepper((prev) => prev + 1);
        }

      } else {
        setUploadErrors(`Please upload a document under ${currentCategory}`)
        setTimeout(() => {
          setUploadErrors("");
        }, 3000);
      }
    } else if (formatType === "department") {
      const currentCategory = categories1[activestepper];
      if (!textInputs[currentCategory]) {
        toast.error("Please enter Department Name");
        return;
      }
      if (!fileInputs1[currentCategory] || fileInputs1[currentCategory].length === 0) {
        toast.error("Please add at least one document");
        return;
      }
      if (areAllFieldsValid(currentCategory)) {
        if (activestepper < categories1.length - 1) {
          setActiveStepper((prev) => prev + 1);
        } else {
          setPrefillLoader(true);
          setTimeout(() => {
            setPrefillLoader(false);
            setActiveStep("step3");
          }, 1000);
        }
      } else {
        setDepartmentValidationError("Please fill all required fields correctly and upload documents")
        setTimeout(() => {
          setDepartmentValidationError('')
        }, 2000)
        const files = (fileInputs1?.[currentCategory]) || [];
        files.forEach((file, docIndex) => {
          const fields = file.fields || {};
          const requiredFields = [
            "typeofdocument",
            "departmentofregistrationandstamps",
            "datethedocumentwasissued",
            "nameofissuingofficer",
            "designationofofficer",
            "officesituatedat"
          ];
          requiredFields.forEach(fieldName => {
            const value = fields[fieldName] || "";
            const error = validateField(fieldName, value) || (!value.trim() ? `This field is required` : "");
            setValidationErrors(prev => {
              const updated = { ...prev };
              if (!updated[currentCategory]) updated[currentCategory] = {};
              if (!updated[currentCategory][docIndex]) updated[currentCategory][docIndex] = {};
              updated[currentCategory][docIndex][fieldName] = error;
              return updated;
            });
          });
          setTimeout(() => {
            setValidationErrors("")
          }, 2000);
          if (!file.file) {
            setValidationErrors(prev => {
              const updated = { ...prev };
              if (!updated[currentCategory]) updated[currentCategory] = {};
              if (!updated[currentCategory][docIndex]) updated[currentCategory][docIndex] = {};
              updated[currentCategory][docIndex]["fileUpload"] = "Please upload a file";
              return updated;
            });
          }
        });
      }
    } else {
      toast.error("Choose your preferred format option");
    }

  };
  const handleDateFormatSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const dateList = dateFiles?.date || [];
    const uploadedFiles = dateList.filter((file) => file && (file.data || file.file));

    if (uploadedFiles.length === 0) {
      setDateFormatError("Please upload at least one document.");
      toast.error("Please upload your document.");
      setTimeout(() => setDateFormatError(""), 3000);
      return;
    }

    const hasStillExtracting = uploadedFiles.some((file) => file.isExtracting);
    if (hasStillExtracting) {
      setDateFormatError("Reading document date... please wait.");
      toast.error("Reading document date... please wait.");
      setTimeout(() => setDateFormatError(""), 3000);
      return;
    }

    const hasEmptyDate = uploadedFiles.some(
      (file) => !file.manualDate || String(file.manualDate).trim() === ""
    );

    if (hasEmptyDate) {
      setDateFormatError("Please select or enter a date for all uploaded documents.");
      toast.error("Please select or enter the date for your uploaded document.");
      setTimeout(() => setDateFormatError(""), 3000);
      return;
    }

    const hasUnconfirmedDate = uploadedFiles.some(
      (file) => !file.declare
    );

    if (hasUnconfirmedDate) {
      setDateFormatError("Please confirm that the date is correct by checking 'I confirm this date is correct'.");
      toast.error("Please check 'I confirm this date is correct' for your document.");
      setTimeout(() => setDateFormatError(""), 3000);
      return;
    }

    setDateFormatError("");
    setPrefillLoader(true);
    setTimeout(() => {
      setPrefillLoader(false);
      setActiveStep("step3");
    }, 1000);
  };
  const addCategory = (e) => {
    e.preventDefault();
    const newCategory = `Category_${categories1.length + 1}`;
    setCategories1((prevCategories) => [...prevCategories, newCategory]);
    setFileInputs1((prevFileInputs) => ({
      ...prevFileInputs,
      [newCategory]: [],
    }));
    setTextInputs((prevTextInputs) => ({
      ...prevTextInputs,
      [newCategory]: "",
    }));
    setActiveStepper(categories1.length);
  };
  const setOpenPaymentShow = () => {
    setRazorPayShow(true)
    setpaymentStatusModel(false)
  }
  const closeTheTab = () => {
    setActiveStep("step4");
    setRazorPayShow(false)
  }
  const [validationErrors, setValidationErrors] = useState({});
  const validateField = (fieldName, value) => {
    let error = "";

    switch (fieldName) {
      case "type_of_document":
        if (!value.trim()) {
          error = "Document type is required";
        }
        break;
      case "department_of_registration_and_stamps":
        if (!value.trim()) {
          error = "Department name is required";
        }
        break;
      case "date_of_the_document_issued":
        if (!value) {
          error = "Date is required";
        } else {
          const selectedDate = new Date(value);
          const today = new Date();
          if (selectedDate > today) {
            error = "Date cannot be in the future";
          }
        }
        break;
      case "issued_by_officer_name":
        if (!value.trim()) {
          error = "Officer name is required";
        }
        break;
      case "officer_designation":
        if (!value.trim()) {
          error = "Officer designation is required";
        }
        break;
      case "office_situated_at":
        if (!value.trim()) {
          error = "Office location is required";
        }
        break;
      default:
        break;
    }

    return error;
  };
  const areAllFieldsValid = (category) => {
    if (!fileInputs1[category] || fileInputs1[category].length === 0) {
      return false;
    }

    let isValid = true;

    for (let docIndex = 0; docIndex < fileInputs1[category].length; docIndex++) {
      if (!fileInputs1[category][docIndex].file) {
        setValidationErrors(prev => {
          const updated = { ...prev };
          if (!updated[category]) updated[category] = {};
          if (!updated[category][docIndex]) updated[category][docIndex] = {};
          updated[category][docIndex]["fileUpload"] = "Please upload a file";
          return updated;
        });

        isValid = false;
      }
      const fields = fileInputs1[category][docIndex]?.fields || {};
      const requiredFields = [
        "typeofdocument",
        "departmentofregistrationandstamps",
        "datethedocumentwasissued",
        "nameofissuingofficer",
        "designationofofficer",
        "officesituatedat"
      ];

      for (const fieldName of requiredFields) {
        const value = fields[fieldName] || "";

        if (!value.trim()) {
          setValidationErrors(prev => {
            const updated = { ...prev };
            if (!updated[category]) updated[category] = {};
            if (!updated[category][docIndex]) updated[category][docIndex] = {};
            updated[category][docIndex][fieldName] = "This field is required";
            return updated;
          });

          isValid = false;
        }
      }
    }
    return isValid;
  };
  const isDocumentUploadReady = () => {
    if (!formatType || isLoading || isSubmittingRequest) return false;

    if (formatType === "regular") {
      const category = categories?.[activestepper];
      if (!category) return false;

      const categoryKey = formatCategoryName(category);
      const files = fileInputs?.[categoryKey] || [];
      const hasUploadedFile = files.some((file) => file?.data || file?.file);
      const isUploading = files.some((file) => file?.loading);
      const hasRequiredDepartment = activestepper < 4 || Boolean(
        (textInputs[categoryKey] || category).trim()
      );

      return hasUploadedFile && !isUploading && hasRequiredDepartment;
    }

    if (formatType === "department") {
      const category = categories1?.[activestepper];
      const files = fileInputs1?.[category] || [];
      const requiredFields = [
        "typeofdocument",
        "departmentofregistrationandstamps",
        "datethedocumentwasissued",
        "nameofissuingofficer",
        "designationofofficer",
        "officesituatedat"
      ];

      return Boolean(category && textInputs[category]?.trim()) && files.length > 0 && files.every((file) => {
        const fields = file?.fields || {};
        return Boolean(file?.file) && requiredFields.every((fieldName) => {
          const value = fields[fieldName] || "";
          return Boolean(value.trim()) && !validateField(fieldName, value);
        });
      });
    }

    if (formatType === "date") {
      const uploadedFiles = (dateFiles?.date || []).filter((file) => file?.data || file?.file);
      return uploadedFiles.length > 0 && uploadedFiles.every((file) =>
        !file.isExtracting && Boolean(String(file.manualDate || "").trim()) && Boolean(file.declare)
      );
    }

    return false;
  };
  const addCategoryRegular = () => {
    const tempCategory = ``;
    setCategories((prev) => [...prev, tempCategory]);
    setFileInputs((prev) => ({
      ...prev,
      [""]: [],
    }));
    setTextInputs((prev) => ({
      ...prev,
      [tempCategory]: "",
    }));

  };
  const removeCategory = (categoryToRemove) => {
    const categoryIndex = categories1.indexOf(categoryToRemove);
    const newCategories = categories1.filter(
      (category) => category !== categoryToRemove
    );
    setCategories1(newCategories);
    const newFileInputs = { ...fileInputs1 };
    delete newFileInputs[categoryToRemove];
    setFileInputs1(newFileInputs);
    const newTextInputs = { ...textInputs };
    delete newTextInputs[categoryToRemove];
    setTextInputs(newTextInputs);
    let newActiveIndex;
    if (newCategories.length === 0) {
      newActiveIndex = 0;
    } else if (categoryIndex > 0) {
      newActiveIndex = categoryIndex - 1;
    } else {
      newActiveIndex = 0;
    }
    setActiveStepper(newActiveIndex);
  };
  const removeCategoryregularformat = (indexToRemove) => {
    const newCategories = categories.filter((_, index) => index !== indexToRemove);
    setCategories(newCategories);

    const categoryKey = categories[indexToRemove];
    const newFileInputs = { ...fileInputs1 };
    delete newFileInputs[categoryKey];
    setFileInputs(newFileInputs);

    const newTextInputs = { ...textInputs };
    delete newTextInputs[categoryKey];
    setTextInputs(newTextInputs);

    let newActiveIndex;
    if (newCategories.length === 0) {
      newActiveIndex = 0;
    } else if (indexToRemove > 0) {
      newActiveIndex = indexToRemove - 1;
    } else {
      newActiveIndex = 0;
    }
    setActiveStepper(newActiveIndex);
  };
  const addFileInput1 = (currentCategory) => {
    if (!currentCategory) return;
    console.log(currentCategory, 'currentCategorysss')
    setFileInputs1((prevInputs) => {
      const existingFiles = (prevInputs?.[currentCategory]) || [];
      const newFile = {
        id: `doc-${Date.now()}`,
        file: null,
        ref: null,
        loading: false,
        fields: {}
      };
      return {
        ...prevInputs,
        [currentCategory]: [...existingFiles, newFile]
      };
    });
  };
  const removeFileInput1 = (category, index) => {
    setFileInputs1((prevFileInputs) => {
      if (prevFileInputs[category] && prevFileInputs[category].length > 0) {
        const updatedCategoryFiles = prevFileInputs[category].filter(
          (_, i) => i !== index
        );
        return {
          [category]: updatedCategoryFiles,
        };
      }
      return prevFileInputs;
    });
  };
  const handleTextInputChange = (category, value) => {
    const formattedCategory = formatCategoryName(category);
    setSearch(value);
    setFilteredOptions(
      dummyData.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      )
    );
    setShowDropdown(true);
    setTextInputs((prev) => ({
      ...prev,
      [formattedCategory]: value,
    }));
  };
  const handleBack = (e) => {
    e.preventDefault();
    if (activestepper > 0) {
      setActiveStepper((prev) => prev - 1);
    }
  };
  const onFileChange = (e, currentCategory, index) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      handleFiles(e, currentCategory, index);
    }
  };
  const handleFiles = async (e, currentCategory, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const f = new FormData();
    f.append("image", file);

    try {
      setFileInputs1((prevState) => {
        const updatedCategoryFiles = [...(prevState[currentCategory] || [])];
        const entry = { ...(updatedCategoryFiles[index] || {}) };
        setIsLoading(true)
        entry.loading = true;
        updatedCategoryFiles[index] = entry;
        return { ...prevState, [currentCategory]: updatedCategoryFiles };
      });

      const response = await PropertiesService.UploadFiles(f);
      if (isApiErrorResponse(response)) {
        const message = getApiErrorMessage(response, 'Unable to upload document');
        setValidationErrors((prev) => ({
          ...prev,
          [currentCategory]: {
            ...(prev[currentCategory] || {}),
            [index]: {
              ...((prev[currentCategory] || {})[index] || {}),
              fileUpload: message,
            },
          },
        }));
        setIsLoading(false);
        return;
      }

      const updated = (prev) => {
        const updatedCategoryFiles = [...(prev[currentCategory] || [])];
        const oldEntry = updatedCategoryFiles[index] || {};

        updatedCategoryFiles[index] = {
          ...oldEntry,
          id: Math.random().toString(36).substr(2, 9),
          name: file.name,
          type: file.type,
          size: file.size,
          file: response.Location,
          previewUrl: response.previewUrl || response.Location,
          loading: false,
        };
        if (validationErrors[currentCategory]?.[index]?.fileUpload) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [currentCategory]: {
              ...(prevErrors[currentCategory] || {}),
              [index]: {
                ...((prevErrors[currentCategory] || {})[index] || {}),
                fileUpload: '',
              },
            },
          }));
        }
        setIsLoading(false)
        console.log(updatedCategoryFiles, 'updatedCategoryFiles')
        return {
          ...prev,
          [currentCategory]: updatedCategoryFiles,
        };
      };

      setFileInputs1((prev) => {
        const updatedInputs = updated(prev);
        console.log(updatedInputs, 'updatedInputs')
        saveUploadedDepartmentFiles(updatedInputs);
        return updatedInputs;
      });
    } catch (error) {
      console.error("Error uploading file:", error);
      const message = getApiErrorMessage(error, 'Unable to upload document');
      setValidationErrors((prev) => ({
        ...prev,
        [currentCategory]: {
          ...(prev[currentCategory] || {}),
          [index]: {
            ...((prev[currentCategory] || {})[index] || {}),
            fileUpload: message,
          },
        },
      }));
      setIsLoading(false);
    }
  };
  const handleFieldChange = (currentCategory, index, fieldName, value) => {
    setFileInputs1((prevState) => {
      const updatedCategoryFiles = [...(prevState[currentCategory] || [])];
      const entry = { ...(updatedCategoryFiles[index] || {}) };
      entry.loading = true;
      updatedCategoryFiles[index] = entry;
      return { ...prevState, [currentCategory]: updatedCategoryFiles };
    });
    const updated = (prev) => {
      const updatedCategoryFiles = [...(prev[currentCategory] || [])];
      const oldEntry = updatedCategoryFiles[index] || {};

      updatedCategoryFiles[index] = {
        ...oldEntry,
        fields: {
          ...(oldEntry.fields || {}),
          [fieldName]: value,
        },
        loading: false,
      };

      return {
        ...prev,
        [currentCategory]: updatedCategoryFiles,
      };
    };

    setFileInputs1((prev) => {
      const updatedInputs = updated(prev);
      saveUploadedDepartmentFiles(updatedInputs);
      return updatedInputs;
    });
  };
  const saveUploadedDepartmentFiles = async (updatedInputs) => {
    const findFilledOrNot = await getActiveRequestPropertyDrafts();
    console.log(updatedInputs, 'updatedInputs')
    if (findFilledOrNot?.length > 0) {
      const draft = findFilledOrNot[0];
      const saveObj = {
        address: draft.address || Address,
        propertyType: draft.propertyType || selectPropertyType,
        region: draft.region || (selectPropertyRegion === "other" ? properRegion : selectPropertyRegion),
        city: draft.city || city,
        state: draft.state || state,
        pincode: draft.pincode || pincode,
        userId: draft.userId || (userDetails ? userDetails.user_id : null),
        DocumentsFormat: formatType || draft.DocumentsFormat || "department",
        sale_Aggrement: draft.sale_Aggrement || ownerShipDoc,
        Declaration: draft.Declaration || (salesAgreement ? salesAgreement : isChecked1),
        propertyId: draft._id,
        documents: {
          categories: categories1,
          files: sanitizeFileInputs2(updatedInputs),
          descriptions: textInputs,
        },
      };
      console.log(saveObj, 'saveObj')
      const response = await PropertiesService.UpdateProperty(saveObj);
      console.log(response, '✅ Fields saved to API');
    }
  };
  const dateFileUpload = async (e, category, id) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("image", file);

    try {
      setIsLoading(true);
      const response = await PropertiesService.UploadFiles(formData);
      if (isApiErrorResponse(response)) {
        const message = getApiErrorMessage(response, 'Unable to upload document');
        setDateFiles((prev) => ({
          ...prev,
          [category]: (prev[category] || []).map((input) =>
            input.id === id ? { ...input, uploadError: message } : input
          ),
        }));
        setIsLoading(false);
        return;
      }
      const data = response.Location;
      const previewUrl = response.previewUrl || response.Location;
      setUploadErrors('');
      setDateFiles((prev) => {
        const updatedCategory = prev[category]
          ? prev[category].map((input) =>
            input.id === id ? { ...input, data, previewUrl, uploadError: '', isExtracting: true, manualDate: '' } : input
          )
          : [];

        const updated = {
          ...prev,
          [category]: updatedCategory,
        };

        saveData(updated);

        return updated;
      });
      setIsLoading(false);

      try {
        const res = await extractDateFromDocument(file, pdfjsLib);
        const extractedDate = res.date || '';
        const detectedAllDates = res.allDates || [];
        setDateFiles((prev) => {
          const updatedCategory = prev[category]
            ? prev[category].map((input) =>
              input.id === id ? {
                ...input,
                manualDate: extractedDate,
                allDates: detectedAllDates,
                declare: !!extractedDate,
                isExtracting: false,
                selectedMode: detectedAllDates.length > 0 ? 'extracted' : 'manual'
              } : input
            )
            : [];
          const updated = { ...prev, [category]: updatedCategory };
          saveData(updated);
          return updated;
        });
      } catch (ocrErr) {
        console.error('OCR Error:', ocrErr);
        setDateFiles((prev) => {
          const updatedCategory = prev[category]
            ? prev[category].map((input) =>
              input.id === id ? { ...input, isExtracting: false, selectedMode: 'manual' } : input
            )
            : [];
          const updated = { ...prev, [category]: updatedCategory };
          saveData(updated);
          return updated;
        });
      }

    } catch (error) {
      const message = getApiErrorMessage(error, 'Unable to upload document');
      setDateFiles((prev) => ({
        ...prev,
        [category]: (prev[category] || []).map((input) =>
          input.id === id ? { ...input, uploadError: message } : input
        ),
      }));
      setIsLoading(false);
    }
  };
  const dateAddFileInput = (category) => {
    const newInput = {
      id: `input-${dateFiles[category]?.length + 1}`,
      data: null,
    };
    setDateFiles((prev) => ({
      ...prev,
      [category]: [...prev[category], newInput],
    }));
  };
  const dateRemoveFileInput = (category, id) => {
    setDateFiles((prev) => {
      if (!prev[category]) return prev;

      const updatedFiles = prev[category].filter((input) => input.id !== id);

      return {
        ...prev,
        [category]: updatedFiles.length > 0 ? updatedFiles : [{ id: "input-1", data: null, manualDate: null }],
      };
    });
    setDates("");
    setManualDate("");
  };
  const renderDepartmentFormat = () => {
    const currentCategory = categories1[activestepper];
    const files = (fileInputs1?.[currentCategory]) || [];
    const isDepartmentUploading = isLoading === true || files.some((file) => file?.loading === true);

    const isDeptSelected = textInputs[currentCategory]?.trim();

    const currentSearchTerm = (textInputs?.[currentCategory] || "").toLowerCase();
    const selectedInOtherCategories = (categories1 || [])
      .filter((cat) => cat !== currentCategory)
      .map((cat) => textInputs?.[cat])
      .filter(Boolean);

    const availableOptions = dummyData
      .filter((item) => item.toLowerCase().includes(currentSearchTerm))
      .filter((item) => !selectedInOtherCategories.includes(item));

    return (
      <div className="dept-wrapper">
        <div className="searchable-select-container" ref={wrapperRef} style={{ marginBottom: '24px' }}>
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="input-with-clear-icon">
                <input
                  type="text"
                  className="searchable-select-input"
                  placeholder="Select department name"
                  value={textInputs[currentCategory] || ""}
                  onChange={(e) => handleTextInputChange(currentCategory, e.target.value)}
                  onFocus={() => setShowDropdown(true)}
                />
                {textInputs[currentCategory] && (
                  <span
                    className="clear-icon"
                    onClick={() => {
                      handleTextInputChange(currentCategory, "");
                      handleSelect("", currentCategory);
                    }}
                  >
                    &times;
                  </span>
                )}
                {showDropdown && (
                  <ul className="searchable-select-dropdown">
                    {availableOptions.length > 0 ? (
                      availableOptions.map((item, index) => (
                        <li
                          key={index}
                          className="searchable-select-option"
                          onClick={() => {
                            handleSelect(item, currentCategory);
                            setShowDropdown(false);
                          }}
                        >
                          {item}
                        </li>
                      ))
                    ) : (
                      <li className="searchable-select-option" style={{ color: '#999', cursor: 'default' }}>No results found</li>
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="dept-grid" style={{
          display: files.length === 1 ? 'flex' : 'grid',
          justifyContent: files.length === 1 ? 'center' : undefined
        }}>
          {files.length > 0 ? (
            files.map((file, docIndex) => (
              <div key={file.id} className={`dept-card ${files.length === 1 ? 'single-card-horizontal' : ''}`} style={{ width: files.length === 1 ? '100%' : undefined, maxWidth: files.length === 1 ? '1100px' : undefined }}>
                <button
                  className="removeIcon"
                  onClick={() => removeFileInput1(currentCategory, docIndex)}
                >
                  ✕
                </button>
                <div className="dept-card-content">
                  <div className="dept-left">
                    <div className={`dept-preview ${file.file ? 'has-file' : ''}`}>
                      {file.loading ? (
                        <div className="loader-container">
                          <img src={loader} alt="Loading..." />
                          <p>Uploading...</p>
                        </div>
                      ) : file.file ? (
                        <FilePreview url={file.file} previewUrl={file.previewUrl} title="Document Preview" className="dept-iframe" height={files.length === 1 ? '280px' : '120px'} isPreviewUrl={true} />
                      ) : (
                        <div
                          className="dept-placeholder"
                          onClick={() => handleClick(file.ref)}
                        >
                          <img src={upload} alt="Upload" width={40} />
                          <p>Upload Your Document</p>
                        </div>
                      )}
                      {validationErrors[currentCategory]?.[docIndex]?.fileUpload && (
                        <p className="dept-error">
                          {validationErrors[currentCategory][docIndex].fileUpload}
                        </p>
                      )}
                    </div>
                    <input
                      type="file"
                      style={{ display: "none" }}
                      ref={(el) => (file.ref = el)}
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.csv,.svg"
                      onChange={(e) => onFileChange(e, currentCategory, docIndex)}
                    />
                  </div>
                  <div className="dept-right">
                    {[
                      "Type Of Document",
                      "Department of Registration and Stamps",
                      "Date the Document was Issued",
                      "Name of Issuing Officer",
                      "Designation of Officer",
                      "Office Situated At",
                    ].map((field, i) => {
                      const fieldKey = field.replace(/[^a-zA-Z0-9]/g, "").toLowerCase().replace(/\s+/g, "_");
                      const fieldId = `field-${docIndex}-${i}`;
                      const errorMessage = validationErrors[currentCategory]?.[docIndex]?.[fieldKey] || "";

                      return (
                        <div key={fieldId} className="dept-field-group">
                          <label className="form-label" htmlFor={fieldId}>{field}</label>
                          <input
                            id={fieldId}
                            type={field === "Date the Document was Issued" ? "date" : "text"}
                            max={field === "Date the Document was Issued" ? new Date().toISOString().split("T")[0] : undefined}
                            placeholder={field}
                            className={`dept-input ${errorMessage ? "error" : ""}`}
                            value={fileInputs1[currentCategory]?.[docIndex]?.fields?.[fieldKey] || ""}
                            onChange={(e) => {
                              let value = e.target.value;
                              if (field === "Date the Document was Issued") {
                                const parts = value.split("-");
                                if (parts[0] && parts[0].length > 4) {
                                  parts[0] = parts[0].slice(0, 4);
                                  value = parts.join("-");
                                }
                              }
                              handleFieldChange(currentCategory, docIndex, fieldKey, value);
                            }}
                            onBlur={(e) => {
                              const error = validateField(fieldKey, e.target.value);
                              setValidationErrors((prev) => {
                                const updated = { ...prev };
                                if (!updated[currentCategory]) updated[currentCategory] = {};
                                if (!updated[currentCategory][docIndex]) updated[currentCategory][docIndex] = {};
                                updated[currentCategory][docIndex][fieldKey] = error;
                                return updated;
                              });
                            }}
                          />
                          {errorMessage && <p className="dept-error">{errorMessage}</p>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ))
          ) : null}
        </div>
        {isDeptSelected && (
          <div
            className={`dept-add-wrapper ${isDepartmentUploading ? "disabled" : ""}`}
            onClick={() => {
              if (isDepartmentUploading) return;
              addFileInput1(currentCategory);
            }}
          >
            <img src={add} width={40} alt="Add" />
            <span>Add Document</span>
          </div>
        )}
      </div>
    );
  };
  const handleOtherPropertyRegion = () => {
    setPropertyEnterText('other')
    setSelectPropertyRegion('other')
  }
  const renderRegularFormat = () => {
    const currentCategory = categories ? categories[activestepper] : "";
    const selectedCategory = textInputs[currentCategory];
    const files = fileInputs[formatCategoryName(currentCategory)] || [];
    const isRegularUploading = isLoading === true || files.some((file) => file?.loading === true);

    // Find other selected departments in indices >= 4
    const selectedInOtherCategories = (categories || [])
      .filter((cat, idx) => idx >= 4 && idx !== activestepper)
      .filter((cat) => cat && cat !== "Government Department Documents");

    // Bind to textInputs if user is typing, otherwise fallback to category name
    const formattedCatName = formatCategoryName(currentCategory);
    const currentInputValue = textInputs[formattedCatName] !== undefined
      ? textInputs[formattedCatName]
      : (currentCategory === "Government Department Documents" ? "" : currentCategory);

    const currentSearchTerm = currentInputValue.toLowerCase();

    const availableOptions = dummyData
      .filter((item) => item.toLowerCase().includes(currentSearchTerm))
      .filter((item) => !selectedInOtherCategories.includes(item));

    return (
      <div className="regular-format-wrapper document-upload">
        {activestepper <= 3 && (<DocumentUploadForm
          category={currentCategory}
          files={fileInputs[formatCategoryName(currentCategory)]}
          handleClick={handleClick}
          handleFileUpload={handleFileUpload}
          addFileInput={addFileInput}
          activestepper={activestepper}
          uploadErrors={uploadErrors}
          filteredOptions={filteredOptions}
          removeFileInput={removeFileInput}
          formatType={formatType}
          Loading={isLoading}
        />)}
        {activestepper >= 4 && (
          <>
            <div className="department-input-group">
              <div className="department-input-wrapper">
                <input
                  type="text"
                  className="department-text-input"
                  placeholder="Enter department name"
                  value={currentInputValue}
                  onChange={(e) =>
                    handleTextInputChange(currentCategory, e.target.value)
                  }
                  onFocus={() => setShowDropdown(true)}
                />
                {showDropdown && (
                  <ul className="department-dropdown">
                    {availableOptions.length > 0 ? (
                      availableOptions.map((item, index) => (
                        <li
                          key={index}
                          className="dropdown-item"
                          onClick={() => handleSelect2(item, currentCategory)}
                        >
                          {item}
                        </li>
                      ))
                    ) : (
                      <li className="dropdown-no-result">No results found</li>
                    )}
                  </ul>
                )}
              </div>
            </div>
            <div className={files.length === 1 ? "row justify-content-center" : "row justify-content-start"}>
              {files.map((input, index) => (
                <div key={input.id} className="col-md-3 document-card">
                  <input
                    type="file"
                    id={input.id}
                    style={{ display: "none" }}
                    ref={(el) => (input.ref = el)}
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
                    onChange={(e) => handleFileUpload(e, currentCategory, input.id)}
                  />
                  <div
                    className="remove-upload"
                    title="Remove Document"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeFileInput(currentCategory, input.id);
                    }}
                  >
                    <span className="x-icon">✕</span>
                  </div>
                  <div className="userImage" onClick={() => handleClick(input.ref)}>
                    {isLoading ? (
                      <div className="loader-container">
                        <img src={loader} alt="Loading..." />
                        <p>Loading...</p>
                      </div>
                    ) : input.data ? (
                      <div>
                        <FilePreview
                          url={input.data}
                          previewUrl={input.previewUrl}
                          width="100%"
                          height="100px"
                          style={{ border: 'none' }}
                          title="Document Viewer"
                          onLoad={onLoad}
                          onError={onError}
                        />
                        {hasError && <p className="error-message">Failed to load document</p>}
                      </div>
                    ) : (
                      <div>
                        <>
                          <img src={upload} width={50} alt="Upload Icon" />
                          <p>Upload Your Document</p>
                        </>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div
              className={`add-doc ${isRegularUploading ? "disabled" : ""}`}
              onClick={() => {
                if (isRegularUploading) return;
                addFileInput(currentCategory);
              }}
            >
              <img src={add} width={40} alt="Add Document" />
            </div>
          </>
        )}
      </div>
    );
  };

  useEffect(() => {
    const modalOverlay = document.querySelector(".modal-overlay");
    if (modalOverlay) {
      if (paymentStatusModel || RazorPayShow) {
        modalOverlay.style.display = "none";
      } else {
        modalOverlay.style.display = "flex";
      }
    }
  }, [paymentStatusModel, RazorPayShow]);

  const renderReviewDocCard = (title, url, previewUrl) => {
    if (!url) return null;
    return (
      <div className="review-doc-card">
        <div className="review-doc-card-header">
          <span className="review-doc-card-icon">📄</span>
          <span className="review-doc-card-title" title={title}>{title}</span>
        </div>
        <div className="review-doc-card-body">
          <FilePreview
            url={url}
            previewUrl={previewUrl || url}
            width="100%"
            height="140px"
            title={title}
            showPreview={true}
          />
        </div>
        <div className="review-doc-card-footer">
          <button
            type="button"
            className="review-doc-btn-preview"
            onClick={() => setPreviewFile({ url, previewUrl: previewUrl || url, title })}
          >
            Preview ↗
          </button>
        </div>
      </div>
    );
  };

  const renderReviewStep = () => {
    return (
      <div className="prestige-form" data-onboarding="review-step">
        <h3 style={{ fontSize: '1.2rem', marginBottom: '20px', color: 'var(--color-oxford-blue)' }}>Review Your Submission</h3>
        <div className="prestige-review-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', background: '#f8f9fa', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <div><strong>Property Type:</strong> {selectPropertyType}</div>
          <div><strong>State:</strong> {state || SelectState}</div>
          <div><strong>District:</strong> {city}</div>
          <div><strong>Mandal:</strong> {selectPropertyRegion === "other" ? properRegion : selectPropertyRegion}</div>
          <div><strong>Village/Locality:</strong> {Address}</div>
          <div><strong>Survey/Plot No:</strong> {PropertyEnterText}</div>
          <div><strong>Pincode:</strong> {pincode}</div>
          <div><strong>Format Type:</strong> {formatType}</div>
        </div>

        <div style={{ marginTop: '20px', borderTop: '1px solid #e5e7eb', paddingTop: '20px' }}>
          <h4 style={{ fontSize: '1rem', marginBottom: '15px', color: 'var(--color-oxford-blue)', fontWeight: 600 }}>Uploaded Documents</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {/* Step 1 Documents */}
            <div style={{ background: '#fff', padding: '12px', borderRadius: '6px', border: '1px solid #e5e7eb' }}>
              <strong style={{ display: 'block', marginBottom: '8px', color: 'var(--color-turquoise-teal)' }}>Step 1: Foundational Documents</strong>
              <div className="review-docs-grid">
                {ownerShipDoc && renderReviewDocCard("Ownership Document", ownerShipDoc, ownerShipDocPreview)}
                {salesAgreement ? (
                  renderReviewDocCard("Sale Agreement", salesAgreement, salesAgreementPreview)
                ) : isChecked1 ? (
                  <div className="review-doc-placeholder">
                    <span className="review-doc-card-icon">✓</span>
                    <span className="review-doc-placeholder-text">Verified full payment to seller</span>
                  </div>
                ) : (
                  <div className="review-doc-placeholder not-provided">
                    <span className="review-doc-card-icon">⚠️</span>
                    <span className="review-doc-placeholder-text">Sale Agreement Not Provided</span>
                  </div>
                )}
              </div>
            </div>

            {/* Step 2 Documents */}
            <div style={{ background: '#fff', padding: '12px', borderRadius: '6px', border: '1px solid #e5e7eb' }}>
              <strong style={{ display: 'block', marginBottom: '8px', color: 'var(--color-turquoise-teal)' }}>Step 2: Format Documents ({formatType || 'None'})</strong>
              {formatType === "regular" && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {Object.keys(fileInputs || {}).map((catKey) => {
                    const files = fileInputs[catKey] || [];
                    const uploadedFiles = files.filter(f => f.data);
                    if (uploadedFiles.length === 0) return null;
                    return (
                      <div key={catKey}>
                        <strong style={{ display: 'block', marginBottom: '8px', color: 'var(--color-oxford-blue)' }}>{catKey.replace(/_/g, ' ')}:</strong>
                        <div className="review-docs-grid">
                          {uploadedFiles.map((f, idx) => (
                            <React.Fragment key={f.id || idx}>
                              {renderReviewDocCard(
                                `${catKey.replace(/_/g, ' ')} - Doc ${idx + 1}`,
                                f.data,
                                f.previewUrl
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {formatType === "department" && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {Object.keys(fileInputs1 || {}).map((catKey) => {
                    const files = fileInputs1[catKey] || [];
                    const uploadedFiles = files.filter(f => f.file || f.name);
                    const deptName = textInputs[catKey] || catKey;
                    if (uploadedFiles.length === 0) return null;
                    return (
                      <div key={catKey} style={{ borderBottom: '1px solid #f3f4f6', paddingBottom: '12px' }}>
                        <strong style={{ display: 'block', marginBottom: '8px', color: 'var(--color-oxford-blue)' }}>Department: {deptName}</strong>
                        <div className="review-docs-grid">
                          {uploadedFiles.map((f, idx) => (
                            <div key={f.id || idx} className="review-doc-card-with-fields">
                              {renderReviewDocCard(
                                f.name || `Document ${idx + 1}`,
                                f.file,
                                f.previewUrl
                              )}
                              {f.fields && (
                                <div className="prestige-review-fields-grid" style={{
                                  display: 'grid',
                                  gridTemplateColumns: '1fr 1fr',
                                  gap: '12px 24px',
                                  color: '#475569',
                                  marginTop: '10px',
                                  fontSize: '0.78rem',
                                  background: '#f8fafc',
                                  padding: '12px 16px',
                                  borderRadius: '8px',
                                  border: '1px solid #e2e8f0'
                                }}>
                                  {Object.keys(f.fields).map(fieldKey => {
                                    const fieldLabels = {
                                      typeofdocument: "Type of Document",
                                      departmentofregistrationandstamps: "Department of Registration and Stamps",
                                      datethedocumentwasissued: "Date the Document Was Issued",
                                      nameofissuingofficer: "Name of Issuing Officer",
                                      designationofofficer: "Designation of Officer",
                                      officesituatedat: "Office Situated At"
                                    };
                                    const displayLabel = fieldLabels[fieldKey.toLowerCase()] || fieldKey.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
                                    let displayVal = f.fields[fieldKey] || 'N/A';
                                    if (fieldKey.toLowerCase() === 'datethedocumentwasissued' && displayVal !== 'N/A') {
                                      displayVal = displayVal.split('-').reverse().join('-');
                                    }
                                    return (
                                      <div key={fieldKey} style={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 }}>
                                        <span style={{ fontWeight: 600, color: '#1e293b', wordBreak: 'break-word' }}>{displayLabel}:</span>
                                        <span style={{ wordBreak: 'break-word', color: '#64748b' }}>{displayVal}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {formatType === "date" && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {Object.keys(dateFiles || {}).map((catKey) => {
                    const files = dateFiles[catKey] || [];
                    const uploadedFiles = files.filter(f => f.data);
                    if (uploadedFiles.length === 0) return null;
                    return (
                      <div key={catKey}>
                        <strong style={{ display: 'block', marginBottom: '8px', color: 'var(--color-oxford-blue)' }}>{catKey.replace(/_/g, ' ')}:</strong>
                        <div className="review-docs-grid">
                          {uploadedFiles.map((f, idx) => (
                            <div key={f.id || idx} className="review-doc-card-with-fields">
                              {renderReviewDocCard(
                                `Document ${idx + 1}`,
                                f.data,
                                f.previewUrl
                              )}
                              {f.manualDate && (
                                <div style={{ fontSize: '0.78rem', color: '#555', padding: '6px 12px', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #e5e7eb', marginTop: '8px' }}>
                                  <strong>Issue Date:</strong> {f.manualDate}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {(!formatType || (!Object.keys(fileInputs || {}).some(k => fileInputs[k]?.some(f => f.data)) &&
                !Object.keys(fileInputs1 || {}).some(k => fileInputs1[k]?.some(f => f.file)) &&
                !Object.keys(dateFiles || {}).some(k => dateFiles[k]?.some(f => f.data)))) && (
                  <span style={{ color: '#999', fontStyle: 'italic', fontSize: '0.85rem' }}>No additional documents uploaded.</span>
                )}
            </div>
          </div>
        </div>

        <div className="prestige-actions">
          <button type="button" className="prestige-btn-back" onClick={() => setActiveStep("step2")}>Back</button>
          <button type="button" className="prestige-btn-next" onClick={submitPropertyRequest} disabled={isSubmittingRequest}>
            {isSubmittingRequest ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    );
  };

  const renderPaymentStep = () => {
    return (
      <div className="prestige-form">
        <div className="w-100 d-flex flex-column align-items-center">
          {paymentDone ? (
            <div className="text-center">
              <img src="https://cdn-icons-png.flaticon.com/512/190/190411.png" alt="Success" width="80" />
              <h4 className="text-success mt-3">Payment Successful</h4>
              <p className="text-muted">Your payment has been processed successfully.</p>
              <Button variant="success" className="mt-4" onClick={RouteToProperties}>Proceed to Properties</Button>
            </div>
          ) : (
            <div style={{ maxWidth: '420px', width: '100%' }}>
              <div data-onboarding="aadhaar-verification" style={{ textAlign: "left", marginBottom: "16px", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "16px", background: '#fff' }}>
                <p style={{ marginBottom: "8px", fontWeight: 600 }}>Aadhaar verification</p>
                <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                  <input
                    type="text"
                    data-onboarding="aadhaar-input"
                    value={aadhaarNumber}
                    onChange={handleAadhaarNumberChange}
                    placeholder="Enter 12-digit Aadhaar number"
                    maxLength={12}
                    style={{ flex: 1, height: "38px", fontSize: "14px", padding: "4px 10px", border: "1px solid #ccc", borderRadius: "4px" }}
                  />
                  {!isAadhaarVerified && (
                    <Button variant="secondary" onClick={handleSendAadhaarOtp} disabled={isSendingAadhaarOtp || aadhaarNumber.length !== 12} style={{ height: "38px" }}>
                      {isSendingAadhaarOtp ? "Sending..." : "Verify"}
                    </Button>
                  )}
                  {isAadhaarVerified && (
                    <span style={{ color: "var(--color-turquoise-teal)", alignSelf: "center", fontWeight: 600 }}>Verified ✓</span>
                  )}
                </div>
                {aadhaarError && <p className="error mb-1">{aadhaarError}</p>}
              </div>

              <PaymentPreviewCard
                baseAmount={18000}
                gstRate={18}
                servicePoints={[
                  "Clearance support for property buying",
                  "Master plan education for future city growth and development",
                  "Civil engineer guidance for investment alignment",
                  "Bank-loan support for safety and security",
                  "Access and support for insurance, government departments and nationalized banks whenver applicable",
                  "Support for title guarantee and property insurance readiness in future",
                ]}
              />

              <div className="prestige-actions">
                <button type="button" className="prestige-btn-back" onClick={() => setActiveStep("step3")}>Back</button>
                {/* <button type="button" className="prestige-btn-next" onClick={handlePayLater} disabled={isPayLaterLoading || !isAadhaarVerified}>
                  {isPayLaterLoading ? "Processing..." : "Submit"}
                </button> */}
                <button type="button" className="prestige-btn-next" onClick={setOpenPaymentShow} disabled={!isAadhaarVerified}>
                  Pay Now
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  const getLineFillWidth = (fromStepKey) => {
    const steps = ["step1", "step2", "step3", "step4"];
    const activeIdx = steps.indexOf(activeStep);
    const fromIdx = steps.indexOf(fromStepKey);

    if (activeIdx > fromIdx) return "100%";
    if (activeIdx === fromIdx) return `${getStepProgressPercent(fromStepKey)}%`;
    return "0%";
  };

  const getLineStatus = (fromStepKey) => {
    const steps = ["step1", "step2", "step3", "step4"];
    const activeIdx = steps.indexOf(activeStep);
    const fromIdx = steps.indexOf(fromStepKey);

    if (activeIdx > fromIdx) return "status-complete";
    if (activeIdx === fromIdx) {
      const pct = getStepProgressPercent(fromStepKey);
      return pct > 0 ? "status-partial" : "status-empty";
    }
    return "status-empty";
  };

  const isStepRequiredFieldsFilled = (stepKey) => {
    switch (stepKey) {
      case "step1":
        return !!(Address && selectPropertyType && selectPropertyRegion && city && SelectState && pincode && ownerShipDoc);
      case "step2":
        let hasFiles = false;
        if (formatType === "regular" && fileInputs) {
          hasFiles = Object.values(fileInputs).some(arr => Array.isArray(arr) && arr.some(file => file && (file.data || file.file)));
        } else if (formatType === "department" && fileInputs1) {
          hasFiles = Object.values(fileInputs1).some(arr => Array.isArray(arr) && arr.some(file => file && (file.file || file.name)));
        } else if (formatType === "date" && dateFiles) {
          const dateList = dateFiles?.date || Object.values(dateFiles).flat();
          const uploadedFiles = dateList.filter(file => file && (file.data || file.file));
          hasFiles = uploadedFiles.length > 0 && uploadedFiles.every(file => file.manualDate && String(file.manualDate).trim() !== "" && file.declare);
        }
        return !!(formatType && hasFiles);
      case "step3":
        return true;
      case "step4":
        return isAadhaarVerified && paymentDone;
      default:
        return false;
    }
  };

  const getStepProgressPercent = (stepKey) => {
    let filledCount = 0;
    let totalFields = 0;

    switch (stepKey) {
      case "step1":
        const step1Fields = [
          propertyRequestSwitch,
          Address,
          selectPropertyRegion,
          selectPropertyType,
          city,
          SelectState,
          pincode,
          ownerShipDoc
        ];
        totalFields = step1Fields.length;
        filledCount = step1Fields.filter(val => val && (typeof val === 'string' ? val.trim() !== "" : true)).length;
        break;

      case "step2":
        totalFields = 2; // formatType and at least one doc
        if (formatType) filledCount++;

        let hasFiles = false;
        if (formatType === "regular" && fileInputs) {
          hasFiles = Object.values(fileInputs).some(arr => Array.isArray(arr) && arr.some(file => file && (file.data || file.file)));
        } else if (formatType === "department" && fileInputs1) {
          hasFiles = Object.values(fileInputs1).some(arr => Array.isArray(arr) && arr.some(file => file && (file.file || file.name)));
        } else if (formatType === "date" && dateFiles) {
          const dateList = dateFiles?.date || Object.values(dateFiles).flat();
          const uploadedFiles = dateList.filter(file => file && (file.data || file.file));
          hasFiles = uploadedFiles.length > 0 && uploadedFiles.every(file => file.manualDate && String(file.manualDate).trim() !== "" && file.declare);
        }
        if (hasFiles) filledCount++;
        break;

      case "step3":
        return activeStep === "step4" ? 100 : (activeStep === "step3" ? 50 : 0);

      case "step4":
        totalFields = 2;
        if (isAadhaarVerified) filledCount++;
        if (paymentDone) filledCount++;
        break;

      default:
        return 0;
    }

    if (totalFields === 0) return 0;

    if (!isStepRequiredFieldsFilled(stepKey)) {
      const pct = Math.round((filledCount / totalFields) * 100);
      return pct === 100 ? 99 : pct;
    }

    return 100;
  };

  const getStepProgress = (stepKey) => {
    const pct = getStepProgressPercent(stepKey);
    if (pct === 100) return "complete";
    if (pct > 0) return "partial";
    return "empty";
  };

  return (
    <div className="prestige-page-bg">
      {showDraftModal && (
        <div className="draft-modal-overlay" onClick={() => setShowDraftModal(false)}>
          <div className="draft-modal-card" onClick={e => e.stopPropagation()}>
            <div className="draft-modal-icon">📋</div>
            <h2 className="draft-modal-title">
              Your previous <strong>property request<br /></strong> is still <strong>on hold</strong>.
            </h2>
            <p className="draft-modal-subtitle">
              Would you like to continue?
            </p>

            <div className="draft-modal-actions">
              <button
                className="draft-modal-btn yes"
                onClick={() => { setShowDraftModal(false); getPropertyDetails(); }}
              >
                Yes
              </button>
              <button
                className="draft-modal-btn no"
                onClick={() => setShowDraftModal(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="prestige-main-container" data-onboarding="form-screen">
        <div className="prestige-header">
          <div className="prestige-header-top">
            <h1 className="prestige-header-title">{propertyRequestSwitch}</h1>
            <div className="prestige-header-nav">
              <span onClick={() => { if (typeof closeModal === 'function') closeModal(); else navigate('/'); }}>Back to Home</span>
            </div>
          </div>
          <div className="prestige-stepper">
            <div className={`prestige-step ${activeStep === "step1" ? "active" : 0 < ["step1", "step2", "step3", "step4"].indexOf(activeStep) ? "status-complete" : "status-empty"}`} onClick={() => handleForms("step1")} style={{ cursor: 'pointer' }}>
              <div className="prestige-step-circle">1</div>
              <div className="prestige-step-label">Property Details</div>
            </div>
            <div className={`prestige-step-line ${getLineStatus("step1")}`}>
              <div
                className={`prestige-step-line-fill ${getLineStatus("step1")}`}
                style={{ width: getLineFillWidth("step1") }}
              ></div>
            </div>
            <div className={`prestige-step ${activeStep === "step2" ? "active" : 1 < ["step1", "step2", "step3", "step4"].indexOf(activeStep) ? "status-complete" : "status-empty"}`} onClick={() => handleForms("step2")} style={{ cursor: 'pointer' }}>
              <div className="prestige-step-circle">2</div>
              <div className="prestige-step-label">Document Upload</div>
            </div>
            <div className={`prestige-step-line ${getLineStatus("step2")}`}>
              <div
                className={`prestige-step-line-fill ${getLineStatus("step2")}`}
                style={{ width: getLineFillWidth("step2") }}
              ></div>
            </div>
            <div className={`prestige-step ${activeStep === "step3" ? "active" : 2 < ["step1", "step2", "step3", "step4"].indexOf(activeStep) ? "status-complete" : "status-empty"}`} onClick={() => handleForms("step3")} style={{ cursor: 'pointer' }}>
              <div className="prestige-step-circle">3</div>
              <div className="prestige-step-label">Review</div>
            </div>
            <div className={`prestige-step-line ${getLineStatus("step3")}`}>
              <div
                className={`prestige-step-line-fill ${getLineStatus("step3")}`}
                style={{ width: getLineFillWidth("step3") }}
              ></div>
            </div>
            <div className={`prestige-step ${activeStep === "step4" ? "active" : "status-empty"}`} onClick={() => handleForms("step4")} style={{ cursor: 'pointer' }}>
              <div className="prestige-step-circle">4</div>
              <div className="prestige-step-label">Verification & Payment</div>
            </div>
          </div>
        </div>

        <div className="prestige-body">
          <div className="prestige-form-col">
            <h2 className="prestige-form-title">{activeStep === "step1" ? "Property Details" : activeStep === "step2" ? "Document Upload" : activeStep === "step3" ? "Review Summary" : "Verification & Payment"}</h2>
            <p className="prestige-form-subtitle">{activeStep === "step1" ? "Provide the foundational information for your asset to begin the certification process." : activeStep === "step2" ? "Upload official documents pertaining to your asset." : activeStep === "step3" ? "Please review your property data carefully before final submission." : "Verify your identity and securely handle any due diligence fees."}</p>

            {formError && (
              <div className="gf-form-error">
                {formError}
              </div>
            )}

            {activeStep === "step1" ? (
              PrefillLoader ? (
                <div className="gf-loader"><FetchingCard sub="This may take a few seconds…" /> </div>
              ) : (
                <form className="prestige-form" data-onboarding-form="dcp" onSubmit={handleRequestedProperty}>

                  <div className="prestige-field-group" data-onboarding="first-property-question">
                    <label className="prestige-label">Type of Property *</label>
                    <div className="prestige-radio-group">
                      <label className={`prestige-radio-card ${selectPropertyType === "agriculture" ? "selected" : ""}`}>
                        <input
                          type="radio"
                          name="selectPropertyType"
                          value="agriculture"
                          checked={selectPropertyType === "agriculture"}
                          onChange={handlePropertyType}
                        />
                        <div className="prestige-radio-circle">
                          <div className="prestige-radio-dot"></div>
                        </div>
                        <span className="prestige-radio-text">Agricultural</span>
                      </label>

                      <label className={`prestige-radio-card ${selectPropertyType === "general" ? "selected" : ""}`}>
                        <input
                          type="radio"
                          name="selectPropertyType"
                          value="general"
                          checked={selectPropertyType === "general"}
                          onChange={handlePropertyType}
                        />
                        <div className="prestige-radio-circle">
                          <div className="prestige-radio-dot"></div>
                        </div>
                        <span className="prestige-radio-text">General</span>
                      </label>
                    </div>
                    {selectPropertyTypeError && <p className="gf-field-error">{selectPropertyTypeError}</p>}
                  </div>

                  <div className="prestige-field-group">
                    <label className="prestige-label">Pincode *</label>
                    <input
                      type="text"
                      className={`prestige-input ${pincodeError ? "gf-error" : ""}`}
                      placeholder="e.g. 500001"
                      value={pincode}
                      onChange={handlePincode}
                      maxLength="6"
                      inputMode="numeric"
                      pattern="[0-9]*"
                    />
                    {pincodeError && <p className="gf-field-error">{pincodeError}</p>}
                  </div>

                  <div className="prestige-field-group">
                    <label className="prestige-label">Full Property Address *</label>
                    <input
                      type="text"
                      className={`prestige-input ${AddressError ? "gf-error" : ""}`}
                      placeholder="Street Address, City, State, ZIP Code"
                      value={Address}
                      onChange={handleAddress}
                    />
                    {AddressError && <p className="gf-field-error">{AddressError}</p>}
                  </div>

                  <div className="prestige-grid-2">
                    <div className="prestige-field-group">
                      <label className="prestige-label">City *</label>
                      <input
                        type="text"
                        className="prestige-input"
                        placeholder="Enter city"
                        value={city}
                        onChange={handleCity}
                      />
                      {cityError && <p className="gf-field-error">{cityError}</p>}
                    </div>

                    <div className="prestige-field-group">
                      <label className="prestige-label">State *</label>
                      <SearchableSelect
                        StatesList={StatesList}
                        SelectState={SelectState}
                        setSelectState={setSelectState}
                        SelectStateError={SelectStateError}
                        EnterState={EnterState}
                        handleEnterState={handleEnterState}
                        inputClassName="prestige-input"
                      />
                      {stateError && <p className="gf-field-error">{stateError}</p>}
                    </div>

                    <div className="prestige-field-group">
                      <label className="prestige-label">Region *</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input
                          type="text"
                          className="prestige-input"
                          placeholder="Select or enter region"
                          value={selectPropertyRegion}
                          onChange={handlePropertyRegion}
                        />
                        <button type="button" className="prestige-btn-back" style={{ padding: '0 12px', background: '#f8f9fa', border: '1px solid #d1d9d6', borderRadius: '4px' }} onClick={() => handleOtherPropertyRegion()}>
                          Other
                        </button>
                      </div>
                      {selectPropertyRegionError && <p className="gf-field-error">{selectPropertyRegionError}</p>}
                    </div>
                  </div>

                  {PropertyEnterText === "other" && (
                    <div className="prestige-field-group">
                      <label className="prestige-label">Enter your property region (manually) *</label>
                      <input
                        type="text"
                        className="prestige-input"
                        placeholder="Manual Region"
                        value={properRegion}
                        onChange={handleEnterPropertyRegion}
                      />
                      {properRegionError && <p className="gf-field-error">{properRegionError}</p>}
                    </div>
                  )}

                  <div className="prestige-field-group" style={{ marginTop: '40px', paddingTop: '30px', borderTop: '1px solid #eef4f1' }}>
                    <label className="prestige-label" style={{ fontSize: '1.1rem', marginBottom: '20px' }}>Documents *</label>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                      <div className="prestige-grid-2" style={{ alignItems: 'center' }}>
                        <div className={`gf-upload ${salesAgreement ? 'gf-uploaded' : ''} ${isChecked1 ? "disabled-upload" : ""}`} style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={saleAgreementRef}
                            accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
                            onChange={(event) => handleFileUpload1(event, "sales")}
                            disabled={isChecked1}
                          />
                          {saleLoading === true ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." style={{ width: '36px' }} />
                              <p style={{ margin: 0, fontSize: '0.8rem' }}>Uploading...</p>
                            </div>
                          ) : salesAgreement && isChecked1 === false ? (
                            <div style={{ position: "relative", width: "100%", maxWidth: "250px", margin: "0 auto" }}>
                              <div
                                className="file-remove-button22"
                                title="Remove Document"
                                style={{ zIndex: 1005 }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSalesAgreement("");
                                  if (saleAgreementRef.current) {
                                    saleAgreementRef.current.value = null;
                                  }
                                }}
                              >
                                <span className="x-icon">✕</span>
                              </div>

                              <FilePreview
                                url={salesAgreement}
                                previewUrl={salesAgreementPreview || salesAgreement}
                                width="100%"
                                height="150px"
                                style={{ border: "none", margin: "0 auto", borderRadius: "8px" }}
                                title="Document Viewer"
                                onLoad={onLoad}
                                onError={onError}
                              />
                              {hasError && (
                                <p className="error-message">Failed to load document</p>
                              )}
                            </div>
                          ) : (
                            <div
                              onClick={() => {
                                if (!isChecked1 && saleAgreementRef.current) {
                                  saleAgreementRef.current.click();
                                }
                              }}
                              style={{ cursor: isChecked1 ? "not-allowed" : "pointer" }}
                            >
                              <img src={upload} width={36} alt="Upload Icon" style={{ opacity: 0.6 }} />
                              <p className="gf-upload-label" style={{ fontWeight: 500, margin: '8px 0 0' }}>Upload Sale Agreement / Draft</p>
                            </div>
                          )}
                          {singleDocumentErrors.sales && (
                            <p className="gf-field-error">{singleDocumentErrors.sales}</p>
                          )}
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', justifyContent: 'center', height: '100%', padding: '20px', border: '1px dashed var(--color-turquoise-teal)', borderRadius: '8px', background: 'rgba(31, 182, 166, 0.02)' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px' }}>
                            <strong style={{ fontSize: '0.8rem', color: 'var(--color-turquoise-teal)' }}>OR VERIFY INSTEAD</strong>
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8px', alignItems: 'center', margin: 0 }}>
                            <input
                              type="checkbox"
                              id="declarePayment"
                              onChange={handleCheckboxChange1}
                              disabled={salesAgreement}
                              checked={isChecked1}
                              style={{ width: '18px', height: '18px', margin: 0, cursor: salesAgreement ? 'not-allowed' : 'pointer' }}
                            />
                            <label htmlFor="declarePayment" className="gf-check-text" style={{ fontSize: '0.95rem', fontWeight: '500', color: 'var(--color-oxford-blue)', margin: 0, cursor: salesAgreement ? 'not-allowed' : 'pointer', textAlign: 'left' }}>
                              I verify that full payment to the seller has been processed.
                            </label>
                          </div>
                        </div>
                      </div>

                      {(isChecked1 || salesAgreement) && (
                        <div className={`gf-upload ${ownerShipDoc ? 'gf-uploaded' : ''}`}>
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={ownershipDocRef}
                            accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
                            onChange={(event) => handleFileUpload1(event, "owner")}
                          />
                          {ownerLoading === true ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." style={{ width: '36px' }} />
                              <p style={{ margin: 0, fontSize: '0.8rem' }}>Uploading...</p>
                            </div>
                          ) : ownerShipDoc ? (
                            <div style={{ position: "relative", width: "250px", margin: "0 auto" }}>
                              <div
                                className="file-remove-button22"
                                title="Remove Document"
                                style={{ zIndex: 1005 }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOwnerShipDoc("");
                                  if (ownershipDocRef.current) {
                                    ownershipDocRef.current.value = null;
                                  }
                                }}
                              >
                                <span className="x-icon">✕</span>
                              </div>

                              <FilePreview
                                url={ownerShipDoc}
                                previewUrl={ownerShipDocPreview || ownerShipDoc}
                                width="250px"
                                height="150px"
                                style={{ border: "none", margin: "0 auto", borderRadius: "8px" }}
                                title="Document Viewer"
                                onLoad={onLoad}
                                onError={onError}
                              />
                              {hasError && (
                                <p className="error-message">Failed to load document</p>
                              )}
                            </div>
                          ) : (
                            <div onClick={() => ownershipDocRef.current.click()}>
                              <img src={upload} width={36} alt="Upload Icon" style={{ opacity: 0.6 }} />
                              <p className="gf-upload-label" style={{ fontWeight: 500, margin: '8px 0 0' }}>Upload Your Ownership Document</p>
                            </div>
                          )}
                          {singleDocumentErrors.owner && (
                            <p className="gf-field-error">{singleDocumentErrors.owner}</p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="prestige-actions">
                    <div />
                    <button
                      type="submit"
                      className="prestige-btn-next"
                      disabled={
                        isSubmittingRequest ||
                        AddressError ||
                        selectPropertyRegionError ||
                        selectPropertyTypeError ||
                        !selectPropertyType ||
                        cityError ||
                        stateError ||
                        pincodeError ||
                        !ownerShipDoc
                      }
                    >
                      {isSubmittingRequest ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </form>
              )
            ) : activeStep === "step2" ? (
              PrefillLoader ? (
                <div className="gf-loader"><FetchingCard sub="This may take a few seconds…" /> </div>
              ) : (
                <>
                  {error && <div className="gf-form-error">{error}</div>}
                  <form className="prestige-form" onSubmit={(e) => e.preventDefault()}>
                    <div className="prestige-field-group">
                      <label className="prestige-label" data-onboarding="format-choice" style={{ fontSize: '1.1rem', marginBottom: '16px' }}>Choose Document Format Option *</label>
                      <div className="prestige-radio-group" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                        <label className={`prestige-radio-card ${formatType === "regular" ? "selected" : ""}`}>
                          <input
                            type="radio"
                            name="formatType"
                            value="regular"
                            checked={formatType === "regular"}
                            onChange={handleFormats}
                          />
                          <div className="prestige-radio-circle">
                            <div className="prestige-radio-dot"></div>
                          </div>
                          <span className="prestige-radio-text">Regular Format</span>
                        </label>
                        <label className={`prestige-radio-card ${formatType === "date" ? "selected" : ""}`}>
                          <input
                            type="radio"
                            name="formatType"
                            value="date"
                            checked={formatType === "date"}
                            onChange={handleFormats}
                          />
                          <div className="prestige-radio-circle">
                            <div className="prestige-radio-dot"></div>
                          </div>
                          <span className="prestige-radio-text">Date Format</span>
                        </label>
                        <label className={`prestige-radio-card ${formatType === "department" ? "selected" : ""}`}>
                          <input
                            type="radio"
                            name="formatType"
                            value="department"
                            checked={formatType === "department"}
                            onChange={handleFormats}
                          />
                          <div className="prestige-radio-circle">
                            <div className="prestige-radio-dot"></div>
                          </div>
                          <span className="prestige-radio-text">Department Format</span>
                        </label>
                      </div>
                    </div>

                    {formatType === "regular" ? (
                      <div className="gf-section" data-onboarding="document-upload">
                        <div className="gf-stepper-tabs">
                          {categories?.map((label, index) => (
                            <button
                              key={index}
                              type="button"
                              className={`gf-stepper-tab ${activestepper === index ? "gf-tab-active" : ""} ${index < categories.length && activestepper > index ? "gf-tab-done" : ""
                                }`}
                              onClick={() => handleStepClick(index, categories[index - 1])}
                            >
                              {index + 1}. {label.slice(0, 15)}{label.length > 15 ? '...' : ''}
                              {index > 3 && (
                                <span
                                  style={{ marginLeft: '8px', color: 'var(--color-oxford-blue)', cursor: 'pointer' }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeCategoryregularformat(index);
                                  }}
                                >
                                  &times;
                                </span>
                              )}
                            </button>
                          ))}
                        </div>
                        <div className="gf-stepper-content">
                          {renderRegularFormat()}
                          {activestepper === categories?.length - 1 && (
                            <div className="gf-note" style={{ marginTop: '16px' }}>
                              <strong>Note:</strong> The master plan is important when you register this property. Please upload the master plan that applies to the property you are submitting.
                            </div>
                          )}
                          <div className="gf-action-row" style={{ boxShadow: 'none', padding: '16px 0 0' }}>
                            <button
                              type="button"
                              className="gf-btn-secondary"
                              onClick={activestepper > 0 ? handleBack : () => setActiveStep("step1")}
                            >
                              Back
                            </button>
                            <div style={{ display: 'flex', gap: '8px' }}>
                              <button
                                type="button"
                                className="gf-btn-primary"
                                onClick={handleNext}
                                disabled={!isDocumentUploadReady()}
                              >
                                {isSubmittingRequest ? "Submitting..." : "Submit"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : formatType === "date" ? (
                      <div className="gf-section" data-onboarding="document-upload">
                        <div className="gf-stepper-content">
                          <DocumentUploadForm
                            category="date"
                            files={dateFiles["date"]}
                            handleClick={handleClick}
                            handleFileUpload={dateFileUpload}
                            handleManualDateChange={handleManualDateChange}
                            addFileInput={() => dateAddFileInput("date")}
                            removeFileInput={dateRemoveFileInput}
                            formatType={formatType}
                            Loading={isLoading}
                          />
                          {DateFormatError && <p className="gf-field-error">{DateFormatError}</p>}

                          <div className="gf-note" style={{ marginTop: '16px' }}>
                            <strong>Note:</strong> The master plan is important when you register this property. Please upload the master plan that applies to the property you are submitting.
                          </div>

                          <div className="gf-action-row" style={{ boxShadow: 'none', padding: '16px 0 0' }}>
                            <button
                              type="button"
                              className="gf-btn-secondary"
                              onClick={() => setActiveStep("step1")}
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              className="gf-btn-primary"
                              onClick={handleDateFormatSubmit}
                              disabled={!isDocumentUploadReady()}
                            >
                              {isSubmittingRequest ? "Submitting..." : "Submit"}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : formatType === "department" ? (
                      <div className="gf-section" data-onboarding="document-upload">
                        <div className="stepper-container">
                          <div className="stepper" style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
                            {(() => {
                              const visibleCategories = categories1.map((label, index) => ({
                                label,
                                originalIndex: index,
                                selectedName: textInputs[label],
                              })).filter((cat) => cat.originalIndex === activestepper || cat.selectedName);

                              return visibleCategories.map((cat, visibleIndex) => {
                                const { label, originalIndex, selectedName } = cat;
                                const isLast = visibleIndex === visibleCategories.length - 1;
                                return (
                                  <React.Fragment key={originalIndex}>
                                    <div
                                      className={`step ${activestepper === originalIndex ? "active" : ""} ${activestepper > originalIndex ? "completed" : ""}`}
                                      title={selectedName || "Select Department"}
                                    >
                                      <div className="d-flex align-items-center mb-3">
                                        <img
                                          src={del}
                                          onClick={() => removeCategory(label)}
                                          style={{
                                            display: categories1.length === 1 ? "none" : "block",
                                          }}
                                          width={20}
                                        />
                                      </div>
                                      <div
                                        onClick={() =>
                                          handleStepClick(originalIndex, categories1[originalIndex - 1])
                                        }
                                      >
                                        <div className="circle">{visibleIndex + 1}</div>
                                        <div className="step-label" style={{ fontSize: '12px', marginTop: '4px', textAlign: 'center', color: 'var(--color-oxford-blue)' }}>
                                          {selectedName || "Select Department"}
                                        </div>
                                      </div>
                                    </div>
                                    {!isLast && (
                                      <div className={`step-line ${activestepper > originalIndex ? 'completed' : ''}`} />
                                    )}
                                  </React.Fragment>
                                );
                              });
                            })()}

                            <div className="add-category-step-wrapper">
                              <button
                                type="button"
                                className="add-category-step-btn"
                                onClick={addCategory}
                                title="Add Another Department"
                              >
                                <span className="add-icon">+</span>
                                <span className="add-text">Add Department</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="gf-stepper-content">
                          {renderDepartmentFormat()}
                          {DepartmentValidationError && <p className="gf-field-error">{DepartmentValidationError}</p>}

                          {activestepper === categories1.length - 1 && (
                            <div className="gf-note" style={{ marginTop: '16px' }}>
                              <strong>Note:</strong> The master plan is important when you register this property. Please upload the master plan that applies to the property you are submitting.
                            </div>
                          )}

                          <div className="gf-action-row" style={{ boxShadow: 'none', padding: '16px 0 0' }}>
                            <button
                              type="button"
                              className="gf-btn-secondary"
                              onClick={activestepper > 0 ? handleBack : () => setActiveStep("step1")}
                            >
                              Back
                            </button>
                            <div style={{ display: 'flex', gap: '8px' }}>
                              <button
                                type="button"
                                className="gf-btn-primary"
                                onClick={handleNext}
                                disabled={!isDocumentUploadReady()}
                              >
                                {isSubmittingRequest ? "Submitting..." : "Submit"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="gf-section" data-onboarding="document-upload">
                        <div className="gf-section-body" style={{ textAlign: 'center', color: 'var(--color-turquoise-teal)' }}>
                          Choose your preferred format option above to proceed.
                        </div>
                      </div>
                    )}
                  </form>
                </>
              )
            ) : activeStep === "step3" ? (
              renderReviewStep()
            ) : activeStep === "step4" ? (
              renderPaymentStep()
            ) : null}
          </div> {/* End prestige-form-col */}

          {/* <div className="prestige-sidebar-col d-none d-lg-flex">
            <div className="prestige-info-card">
              <div className="prestige-info-item">
                <div className="prestige-info-icon">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                </div>
                <h3 className="prestige-info-title">Private & Confidential</h3>
                <p className="prestige-info-text">All property data is handled with institutional-grade security. Your asset information is encrypted and shared only with certified advisors.</p>
              </div>
              <div className="prestige-info-item">
                <div className="prestige-info-icon">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </div>
                <h3 className="prestige-info-title">48-Hour Response</h3>
                <p className="prestige-info-text">Once your submission is complete, our senior advisory board will review the property profile and issue an initial feasibility report within two business days.</p>
              </div>
            </div>
          </div> */}
        </div>
      </div>


      <Modal show={RazorPayShow} size="md" onHide={handleClose} centered>
        <Modal.Header>
          <div className="row setCenter w-100" style={{ margin: 0 }}>
            <div className="col-md-12 text-end">
              {paymentStatus === false && <span style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={closeTheTab}>&times;</span>}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">
          <div className="card-body p-4 w-100 text-center">
            <Product
              amount={18000}
              gstRate={18}
              currency="INR"
              paymentFor="requestForProperty"
              userId={PropertyResponse?.userId}
              onPaymentStatusChange={setPaymentStatus}
              paymentRequestId={PropertyResponse}
              paymentStatus={paymentStatus}
              setIsModalOpen={setIsModalOpen}
              SuccessStatus="beforeRequest"
              paymentMessage="Property"
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showAadhaarOtpModal} size="sm" onHide={() => setShowAadhaarOtpModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Verify Aadhaar OTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            value={aadhaarOtp}
            onChange={handleAadhaarOtpChange}
            placeholder="Enter 6-digit OTP"
            maxLength={6}
            className="form-control"
          />
          {aadhaarError && <p className="error mt-2 mb-0">{aadhaarError}</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAadhaarOtpModal(false)}>
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleVerifyAadhaarOtp}
            disabled={isVerifyingAadhaarOtp || aadhaarOtp.length !== 6}
          >
            {isVerifyingAadhaarOtp ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Fullscreen Document Preview Modal */}
      <Modal
        show={!!previewFile}
        onHide={() => setPreviewFile(null)}
        size="lg"
        centered
        className="document-preview-modal"
      >
        <Modal.Header closeButton style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Modal.Title style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--color-oxford-blue)', margin: 0 }}>
            {previewFile?.title || "Document Preview"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '16px', background: '#f8f9fa', minHeight: '520px' }}>
          {previewFile && (
            <FilePreview
              url={previewFile.url}
              previewUrl={previewFile.previewUrl || previewFile.url}
              width="100%"
              height="500px"
              title={previewFile.title}
              showPreview={true}
            />
          )}
        </Modal.Body>
      </Modal>

      <ToastContainer autoClose={2000} />
      <Footer />
    </div>
  );
};
export default RequestProperty;

